import {
  AlertColor,
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Tooltip,
} from '@mui/material';
import MediumTypography from '../../components/formlib/MediumTypography';
import AppTimePicker from '../../components/formlib/AppTimePicker';
import VoiceRecognition, {
  turnOfMic,
} from '../../components/formlib/VoiceRecognition';
import ButtonComponent from '../../components/formlib/ButtonComponent';
import { useContext, useEffect, useRef, useState } from 'react';
import { Formik, FormikErrors, FormikProps } from 'formik';
import * as yup from 'yup';
import { useLocation, useNavigate } from 'react-router';
import {
  ProgressNoteType,
  ProgressNoteContact,
  ProgressNoteClient,
  ProgressNoteVisit,
  OptionType,
  SignatureStateType,
  ProgressNoteSignature,
  AttendeeRole,
} from '../../utils/type';
import { ReactComponent as Editsignature } from '../../assets/images/editsignature.svg';
import { ReactComponent as Stop } from '../../assets/images/stopRed.svg';
import { ReactComponent as StopWhite } from '../../assets/images/stopWhite.svg';
import MultipleAutocompleteSearch from '../../components/formlib/MultipleAutocompleteSearch';
import CustomRadioButton, {
  RadioButtonData,
} from '../../components/formlib/CustomRadioButton';
import {
  CreateDeleteProgressNote,
  EditProgressNote,
  UpdateGroupBillig,
  downloadProgressNote,
} from '../../services/progressNotes/ProgressNotesApi';
import moment from 'moment';
import { ReactComponent as Delete } from '../../assets/images/deleteAlertIcon.svg';
import './listeningDot.css';
import { LoaderContext, LoaderContextType } from '../../layouts/AppSidebar';
import {
  ACTIVITY_APPROVAL_SHEET_ROUTE_NAME,
  ACTIVITY_SHEET_ROUTE_NAME,
  PROGRESS_NOTE_FACESHEET,
  PROGRESS_NOTE_LIST_ROUTE_NAME,
  SCHEDULER_ROUTE_NAME,
} from '../../routes/Routing';
import dayjs, { Dayjs } from 'dayjs';
import ModalPopup from '../../components/formlib/ModalPopup';
import SnackBarComponent from '../../components/formlib/SnackBarComponent';
import {
  ApiError,
  ApiMessage,
  isCustomError,
} from '../../services/ApiResponseHandler';
import { IdType } from './ProgressNoteSetup';
import {
  LOCAL_DATE_TIME_FORMAT,
  STORAGE_USER_ID_KEY,
  STORAGE_USERFIRSTNAME_KEY,
  STORAGE_USERLASTNAME_KEY,
  STORAGE_USERNAME_KEY,
} from '../../services/Constant';
import AutocompleteSearch from '../../components/formlib/AutocompleteSearch';
import ThomProgram from '../../assets/images/thomchildlogo.svg';
import { ReactComponent as DownArrow } from '../../assets/images/downarrowcolored.svg';
import { ReactComponent as UpArrow } from '../../assets/images/uparrowcolored.svg';
import { ReactComponent as Undo } from '../../assets/images/undoIcon1.svg';
import { ReactComponent as EditIcon } from '../../assets/images/Edit.svg';
import SignatureComponent from '../../components/formlib/modal/SignatureComponent';
import _, { debounce } from 'lodash';
import DurationPicker from '../../components/formlib/DurationPicker';
import {
  formatToDecimalFromDuration,
  formatToDurationFromDecimal,
} from '../../utils/dateUtil';
import { convertGenderToFrontend } from '../../utils/genderUtil';
import { ReactComponent as DownloadIcon } from '../../assets/images/downloadIconGreen.svg';

import SelectedContacts from './SelectedContacts';
import Textinput from '../../components/formlib/Textinput';

import CancelVisits from './CancelVisits';
import { LookUpContext } from '../../context/LookUpContextProvider';
import { LookupItem } from '../../services/configApi/tcsLookups';
import { checkOffline } from '../../services/Offline';
import ShareDownloadModal from '../../components/formlib/modal/ShareDownloadModal';
import LanguageSelectionDialog from '../../components/shared/LanguageSelectionDialog';
import ToolTipIcon from '../../components/formlib/ToolTipIcon';
import { ReactComponent as ShareIcon } from '../../assets/images/shareGreen.svg';
import { useIntl } from 'react-intl';
import { formatName } from '../../utils/nameUtils';
import { UnSavedChangesContext } from '../../context/UnSavedChangesProvider';
import CheckBoxComponent from '../../components/formlib/CheckBoxComponent';
import ServiceCodeValidationModal, {
  ServiceCodeValidationDataProps,
} from './ServiceCodeValidationModal';
import ProgramPanel from '../../components/forms/ProgramPanel';
import { formatNumberToDecimal, getStatusColor } from '../../utils/utilities';
import { getClientDocumentFileName } from '../../utils/fileUtils';
import { usePermissions } from '../../hooks/usePermissions';
import { ConsentClientSignature } from '../../services/configApi/forms/Consent/ConsentServices';
import { StatusType } from '../activitySheet/ActivityTableRow';

type SelectedClientListType = {
  progressNoteId: string;
  clientId: string;
  clientName?: string;
  isSelected: boolean;
};

export type CreateDeleteProgressNoteType = {
  clients: SelectedClientListType[];
};

interface Code {
  id: string;
  codeId: number;
  code: string;
  description: string;
}

export interface CodeListType {
  settingCode: Code[];
  serviceCode: Code[];
}

const appointmentStageRadioData = [
  {
    value: 'evaluation',
    labelId: 'ProgressNote.Evaluation',
    defaultLabel: 'Evaluation',
  },
  {
    value: 'ifsp',
    labelId: 'ProgressNote.IFSP',
    defaultLabel: 'IFSP',
  },
  {
    value: 'other',
    labelId: 'otherText',
    defaultLabel: 'Other',
  },
];

const TeleHealthRadioData = [
  { value: 'audio', labelId: 'ProgressNote.Audio', defaultLabel: 'Audio' },
  { value: 'video', labelId: 'ProgressNote.Video', defaultLabel: 'Video' },
];

export type Data = {
  name: string;
  createdOn: string;
  createdBy: string;
  program: string;
  actions: string;
  modifiedBy: string;
  modifiedOn: string;
};

export type SelectedRowType = {
  id: string;
  clientId: string;
};

const propertiesToCheck = [
  'individualHrsDec',
  'coTreatmentHrsDec',
  'tpc',
  'telehealth',
  'telehealthType',
  'providerLocationType',
  'visits',
  'selectedContacts',
  'othersPresentInVisit',
  'notes',
  'signature',
  'status',
];

const propertiesToCheckInVisits = [
  'startTime',
  'clientLocationType',
  'serviceCode',
  'settingCode',
  'coTx',
  'ifspMeeting',
  'asessmentHomeVisit',
  'supervisionCoTxHV',
] as const;

let hasChanged = false;

const ProgressNote = (props: IdType) => {
  const [validUser, setValidUser] = useState<boolean>(false);
  const [startDuration, setStartDuration] = useState<number>(0);
  const [endDuration, setEndDuration] = useState<number>(15);
  const [settingChange, setSettingChange] = useState<boolean>(false);
  const [localAppointmentDate, setLocalAppointmentDate] = useState<string>('');
  const [localAppointmentTime, setLocalAppointmentTime] = useState<string>('');
  const [noteError, setNoteError] = useState<boolean>(false);
  const [signClicked, setSignClicked] = useState<boolean>(false);
  const [showAlertDialog, setShowAlertDialog] = useState<boolean>(false);
  const [multiSelectContact, setMultiSelectContact] = useState<
    ProgressNoteContact[]
  >([]);
  const [attendeeName, setAttendeeName] = useState<string>('');
  const [attendeeLicenseNo, setAttendeeLicenseNo] = useState<string>('');
  const [attendeeDiscipline, setAttendeeDiscipline] = useState<string>('');
  const [open, setOpen] = useState<boolean>(false);
  const [toastrVariable, setToastrVariable] = useState<AlertColor>('info');
  const [toastrDefaultMessage, setToastrDefaultMessage] = useState('');
  const [toastrId, setToastrId] = useState('');

  const [initialData, setInitialData] = useState<ProgressNoteType | null>(null);
  const [origainalInitialData, setOrigainalInitialData] =
    useState<ProgressNoteType | null>(null);
  const [clientLocation, setClientLocation] = useState<OptionType[]>([]);

  const [serviceCode, setServiceCode] = useState<LookupItem[]>([]);
  const [settingCode, setSettingCode] = useState<LookupItem[]>([]);
  const [firstEntry, setFirstEntry] = useState<boolean>(true);
  const [isAddOrDeleteClientAction, setIsAddOrDeleteClientAction] =
    useState<boolean>(false);
  const [openClientModal, setOpenClientModal] = useState<boolean>(false);
  const [selectedClient, setSelectedClient] = useState<
    SelectedClientListType[]
  >([]);
  const [shareClientIds, setShareClientIds] = useState<{
    clientId: string;
    referralId: string;
  } | null>(null);
  const [shareModal, setShareModal] = useState<boolean>(false);
  const [openDownloadLanguageModal, setOpenDownloadLanguageModal] =
    useState<boolean>(false);
  const [downloadParams, setDownloadParams] = useState<{
    clientId: string;
    attendeeId: string;
    appointmentId: string;
  } | null>(null);
  const [clientCheckList, setClientCheckList] = useState<
    SelectedClientListType[]
  >([]);
  const [clientCheckListInitial, setClientCheckListInitial] = useState<
    SelectedClientListType[]
  >([]);
  const [durationClickedIndex] = useState<number>(0);
  const [openAccordian, setOpenAccordian] = useState<boolean>(true);
  const [openAccordianIndex, setOpenAccordianIndex] = useState<number>(0);
  const [clientCount, setClientCount] = useState<number>(0);
  const [isAnyDurationZero, setIsAnyDurationZero] = useState<boolean>(false);
  const [offline, setOffline] = useState<boolean>(false);
  const [screenFrom, setScreenFrom] = useState<string>('');
  const [openCancelVisitModal, setOpenCancelVisitModal] =
    useState<boolean>(false);
  const [isScreenLocked, setIsScreenLocked] = useState<boolean>(false);
  const [groupBillingStartTime, setGroupBillingStartTime] = useState<
    string | null
  >('');
  const [groupBillingDuration, setGroupBillingDuration] = useState<number>(0.0);
  const [initialGroupBillingDuration, setInitialGroupBillingDuration] =
    useState<number>(0.0);
  const [initialGroupBillingStartTime, setInitialGroupBillingStartTime] =
    useState<string>('');
  const [groupBillingCancelModal, setGroupBillingCancelModal] =
    useState<boolean>(false);
  const parentRef = useRef<HTMLDivElement>(null);
  const { lookups } = useContext(LookUpContext);
  const rctl = useIntl();
  const { state } = useLocation();
  const [currentVisitIndex, setCurrentVisitIndex] = useState<number>(0);
  const [editClientIndex, setEditClientIndex] = useState<number | null>(null);
  const [editConfirmOpen, setEditConfirmOpen] = useState<boolean>(false);
  const [editSignClicked, setEditSignClicked] = useState<boolean>(false);
  const [isAnyVisitsHasApproved, setIsAnyVisitsHasApproved] =
    useState<boolean>(false);
  const progressNotePermission = usePermissions(
    'backend.update_staff_progress_notes',
  );
  const editPayloadRef = useRef<{ comments: string; signatureValue: string }>({
    comments: '',
    signatureValue: '',
  });
  const [historySignature, setHistorySignature] = useState<{
    signature:
      | (ConsentClientSignature & {
          comment: string;
        })
      | null;
    open: boolean;
  } | null>(null);

  // Helper function to safely get localStorage items with fallback
  const getLocalStorageItem = (key: string, fallback: string = ''): string => {
    try {
      return localStorage.getItem(key) ?? fallback;
    } catch (error) {
      console.warn(
        `localStorage access failed for key: ${key}`,
        error,
        isAnyVisitsHasApproved,
      );
      return fallback;
    }
  };

  useEffect(() => {
    if (props.clientIdsFromActivity) {
      const selectedData = props.progressNoteData.clients.filter(
        (data) => data.isSelected,
      );
      const index = selectedData.findIndex(
        (data) => data.client.clientId === props.clientIdsFromActivity[0],
      );
      if (index !== -1) {
        setOpenAccordianIndex(index);
      }
    }
  }, [props.clientIdsFromActivity]);

  const formikRef = useRef<FormikProps<ProgressNoteType>>(null);
  useEffect(() => {
    if (lookups === null) {
      return;
    }

    setServiceCode(() => {
      return lookups.serviceCode.map((e) => {
        return e;
      });
    });

    setSettingCode(() => {
      return lookups.settingsCode.map((e) => {
        return e;
      });
    });

    setClientLocation(() => {
      return lookups.location.map((e) => {
        return { id: e.code, label: e.description };
      });
    });
  }, [lookups]);

  useEffect(() => {
    hasChanged = false;
    if (
      initialData?.clients[openAccordianIndex]?.status === 'Canceled' ||
      initialData?.clients[openAccordianIndex]?.canceledReason?.cancelReason ||
      formikRef.current?.values.clients[openAccordianIndex]?.canceledReason
        ?.cancelReason
    ) {
      setIsScreenLocked(true);
    } else {
      setIsScreenLocked(false);
    }
    const initialSelectedContacts = formikRef.current?.values.clients[
      openAccordianIndex
    ].selectedContacts.map((selectedId) =>
      initialData?.clients[openAccordianIndex].contact.find(
        (contact) => contact.contactId === selectedId,
      ),
    );
    if (initialSelectedContacts) {
      setMultiSelectContact(
        initialSelectedContacts.map((contact) => {
          if (!contact) return {};
          const prefixes = [
            contact.isPrimary && 'Primary',
            contact.isLegal && 'Legal',
          ].filter(Boolean);

          const displayName =
            contact.isGuardian && prefixes.length > 0
              ? `${contact.name} - (${prefixes.join(', ')})`
              : contact.name;

          return {
            contactId: contact.contactId,
            email: contact.email,
            homePhoneNumber: contact.homePhoneNumber,
            isPrimary: contact.isPrimary,
            name: displayName ?? 'Referral Contact',
            relationshipToClient: contact.relationshipToClient,
            type: contact.type,
          };
        }) as ProgressNoteContact[],
      );
    }
  }, [initialData?.clients[openAccordianIndex]?.contact, openAccordianIndex]);

  useEffect(() => {
    const getOfflineMode = async () => {
      const offlineFlag = await checkOffline();
      setOffline(offlineFlag);
    };
    getOfflineMode();

    return () => {
      turnOfMic();
    };
  }, []);

  const [serviceCodes, setServiceCodes] =
    useState<ServiceCodeValidationDataProps>();
  const { toggleLoader } = useContext(LoaderContext) as LoaderContextType;
  const { handleUpdateUnsavedChanges } = useContext(UnSavedChangesContext);
  const navigate = useNavigate();
  useEffect(() => {
    const userId = localStorage.getItem(STORAGE_USER_ID_KEY);
    const attendee = props.progressNoteData.clients[
      openAccordianIndex
    ].attendeeList?.find((attendeeList) => attendeeList.attendeeId === userId);
    if (attendee?.attendeeId === props.clickedAttendeeId) {
      setOpenClientModal(true);
      setValidUser(true);
    }

    const iaAnyVisitsApproved = props.progressNoteData.clients.some(
      (client) => {
        return client.visits.some(
          (visit) => visit.activitySheetStatus === 'Approved',
        );
      },
    );
    if (iaAnyVisitsApproved) {
      setIsAnyVisitsHasApproved(true);
    } else {
      setIsAnyVisitsHasApproved(false);
    }

    const isAllNotSelected = props.progressNoteData.clients.every(
      (item) => !item.isSelected,
    );
    if (isAllNotSelected) {
      const mapClientData = (clients: ProgressNoteClient[]) =>
        clients.map((item) => ({
          progressNoteId: item.progressNoteId ? item.progressNoteId : '',
          clientId: item.client.clientId,
          isSelected: true,
          clientName: formatName(
            item.client.firstName,
            item.client.middleName,
            item.client.lastName,
            item.client.suffix,
          ),
        }));
      setSelectedClient(mapClientData(props.progressNoteData.clients));
      setClientCheckList(mapClientData(props.progressNoteData.clients));
      setClientCheckListInitial(mapClientData(props.progressNoteData.clients));
    } else {
      setSelectedClient(
        props.progressNoteData.clients
          .filter((item) => item.isSelected)
          .map((item) => ({
            progressNoteId: item.progressNoteId ? item.progressNoteId : '',
            clientId: item.client.clientId,
            clientName: formatName(
              item.client.firstName,
              item.client.middleName,
              item.client.lastName,
              item.client.suffix,
            ),
            isSelected: true,
          })),
      );

      setClientCheckList(
        props.progressNoteData.clients.map((item) => ({
          progressNoteId: item.progressNoteId ? item.progressNoteId : '',
          clientId: item.client.clientId,
          clientName: formatName(
            item.client.firstName,
            item.client.middleName,
            item.client.lastName,
            item.client.suffix,
          ),
          isSelected: item.isSelected,
        })),
      );
      setClientCheckListInitial(
        props.progressNoteData.clients.map((item) => ({
          progressNoteId: item.progressNoteId ? item.progressNoteId : '',
          clientId: item.client.clientId,
          clientName: formatName(
            item.client.firstName,
            item.client.middleName,
            item.client.lastName,
            item.client.suffix,
          ),
          isSelected: item.isSelected,
        })),
      );
    }
    setClientCount(props.progressNoteData.clients.length);
    setScreenFrom(props.screenFrom);

    const currentAttendee =
      props.progressNoteData.clients[0].attendeeList?.filter(
        (item) => item.attendeeId === props.clickedAttendeeId,
      );
    if (currentAttendee && currentAttendee.length > 0) {
      setAttendeeName(
        currentAttendee[openAccordianIndex]?.lastName +
          ', ' +
          currentAttendee[openAccordianIndex]?.firstName,
      );
      setAttendeeLicenseNo(currentAttendee[openAccordianIndex]?.licenseNo);

      const selectedAttendeeDiscipline =
        lookups?.employeeDiscipline
          .filter(
            (item) =>
              item.code === currentAttendee[openAccordianIndex]?.disciplineType,
          )
          .flatMap((item) => item.description) ?? '';
      setAttendeeDiscipline(selectedAttendeeDiscipline[0] ?? '');
    } else {
      const client = props.progressNoteData?.clients?.[openAccordianIndex];
      const attendees = client?.attendeeList?.[0];

      if (attendees) {
        setAttendeeName(`${attendees.lastName}, ${attendees.firstName}`);
        setAttendeeLicenseNo(attendees.licenseNo);
        setAttendeeDiscipline(attendees.disciplineType);
      } else {
        setAttendeeName('');
        setAttendeeLicenseNo('');
        setAttendeeDiscipline('');
      }
    }
    const localDate = moment(
      props.progressNoteData.clients[openAccordianIndex].appointmentDate,
      'YYYY-MM-DDTHH:mm',
    )
      .utc(true)
      .local()
      .format('MM/DD/YYYY');
    setLocalAppointmentDate(localDate);
    const localTime = moment(
      props.progressNoteData.clients[0].appointmentDate,
      'YYYY-MM-DDTHH:mm',
    )
      .utc(true)
      .local()
      .format('HH:mm A');
    setLocalAppointmentTime(localTime);
    setInitialGroupBillingDuration(
      props.progressNoteData.groupBilling?.groupBillingDurationDec ?? 0.0,
    );

    setInitialGroupBillingStartTime(
      props.progressNoteData.groupBilling?.groupBillingStartTime ?? '',
    );
    setGroupBillingDuration(
      props.progressNoteData.groupBilling?.groupBillingDurationDec ?? 0.0,
    );
    setGroupBillingStartTime(
      props.progressNoteData.groupBilling?.groupBillingStartTime
        ? moment(
            props.progressNoteData.groupBilling?.groupBillingStartTime,
            'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
          )
            .utc(true)
            .local()
            .format('HH:mm')
        : '',
    );
    const mapClientsData = (clients: ProgressNoteClient[]) => {
      return clients
        .filter((item) => item.isSelected)
        .map((item, index) => ({
          ...item,
          coTreatmentHrsDec: item.coTreatmentHrsDec ?? 0,
          individualHrsDec:
            item.individualHrsDec ?? item.visits[0].durationDec ?? 0,
          clientIndex: index,
          visits: mapVisitsData(item.visits, index),
          appointmentId: item.appointmentId,
        }));
    };

    const mapVisitsData = (
      visits: ProgressNoteVisit[],
      clientIndex: number,
    ) => {
      return visits.map((visit) => ({
        ...visit,
        appointmentStage:
          visit.appointmentStage === '' || visit.appointmentStage === null
            ? 'other'
            : visit.appointmentStage,
        clientVisitsIndex: clientIndex,
        startTime: moment(visit.startTime, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]')
          .utc(true)
          .local()
          .format('HH:mm'),
      }));
    };

    setOrigainalInitialData(() => ({
      programDetails: {
        faxNumber: props.progressNoteData.programDetails.faxNumber,
        imageUrl:
          props.progressNoteData.programDetails.imageUrl === ''
            ? ThomProgram
            : props.progressNoteData.programDetails.imageUrl,
        name: props.progressNoteData.programDetails.name,
        phoneNumber: props.progressNoteData.programDetails.phoneNumber,
        addressLine1: props.progressNoteData.programDetails.addressLine1,
        addressLine2: props.progressNoteData.programDetails.addressLine2,
        email: props.progressNoteData.programDetails.email,
        website: props.progressNoteData.programDetails.website,
        city: props.progressNoteData.programDetails.city,
        state: props.progressNoteData.programDetails.state,
        zipCode: props.progressNoteData.programDetails.zipCode,
      },
      clients: mapClientsData(props.progressNoteData.clients),
    }));
    setInitialData(() => ({
      programDetails: {
        faxNumber: props.progressNoteData.programDetails.faxNumber,
        imageUrl:
          props.progressNoteData.programDetails.imageUrl === ''
            ? ThomProgram
            : props.progressNoteData.programDetails.imageUrl,
        name: props.progressNoteData.programDetails.name,
        phoneNumber: props.progressNoteData.programDetails.phoneNumber,
        addressLine1: props.progressNoteData.programDetails.addressLine1,
        addressLine2: props.progressNoteData.programDetails.addressLine2,
        email: props.progressNoteData.programDetails.email,
        website: props.progressNoteData.programDetails.website,
        city: props.progressNoteData.programDetails.city,
        state: props.progressNoteData.programDetails.state,
        zipCode: props.progressNoteData.programDetails.zipCode,
      },
      clients: mapClientsData(props.progressNoteData.clients),
    }));
  }, []);

  useEffect(() => {
    const mapClientsData = (clients: ProgressNoteClient[]) => {
      return clients
        .filter((item) => item.isSelected)
        .map((item, index) => ({
          ...item,
          coTreatmentHrsDec: item.coTreatmentHrsDec ?? 0,
          individualHrsDec:
            item.individualHrsDec ?? item.visits[0].durationDec ?? 0,
          clientIndex: index,
          visits: mapVisitsData(item.visits, index),
          appointmentId: item.appointmentId,
        }));
    };

    const mapVisitsData = (
      visits: ProgressNoteVisit[],
      clientIndex: number,
    ) => {
      return visits.map((visit) => ({
        ...visit,
        appointmentStage:
          visit.appointmentStage === '' || visit.appointmentStage === null
            ? 'other'
            : visit.appointmentStage,
        clientVisitsIndex: clientIndex,
        startTime: moment(visit.startTime, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]')
          .utc(true)
          .local()
          .format('HH:mm'),
      }));
    };

    setOrigainalInitialData(() => ({
      programDetails: {
        faxNumber: props.progressNoteData.programDetails.faxNumber,
        imageUrl:
          props.progressNoteData.programDetails.imageUrl !== ''
            ? props.progressNoteData.programDetails.imageUrl
            : ThomProgram,
        name: props.progressNoteData.programDetails.name,
        phoneNumber: props.progressNoteData.programDetails.phoneNumber,
        addressLine1: props.progressNoteData.programDetails.addressLine1,
        addressLine2: props.progressNoteData.programDetails.addressLine2,
        email: props.progressNoteData.programDetails.email,
        website: props.progressNoteData.programDetails.website,
        city: props.progressNoteData.programDetails.city,
        state: props.progressNoteData.programDetails.state,
        zipCode: props.progressNoteData.programDetails.zipCode,
      },
      clients: mapClientsData(props.progressNoteData.clients).map(
        (client, index) => {
          const existingOriginalClientsData =
            origainalInitialData?.clients || [];

          if (existingOriginalClientsData[index]?.visits) {
            // Update only the `id` field of each visit while keeping other properties unchanged
            existingOriginalClientsData[index].visits =
              existingOriginalClientsData[index].visits.map(
                (visit, vIndex) => ({
                  ...visit,
                  id: client.visits[vIndex]?.id, // Update only the `id`
                }),
              );
          }
          if (isAddOrDeleteClientAction) {
            return client;
          }
          return index === openAccordianIndex
            ? client
            : existingOriginalClientsData[index] || client;
        },
      ),
    }));
    setInitialData(() => ({
      programDetails: {
        faxNumber: props.progressNoteData.programDetails.faxNumber,
        imageUrl:
          props.progressNoteData.programDetails.imageUrl !== ''
            ? props.progressNoteData.programDetails.imageUrl
            : ThomProgram,
        name: props.progressNoteData.programDetails.name,
        phoneNumber: props.progressNoteData.programDetails.phoneNumber,
        addressLine1: props.progressNoteData.programDetails.addressLine1,
        addressLine2: props.progressNoteData.programDetails.addressLine2,
        email: props.progressNoteData.programDetails.email,
        website: props.progressNoteData.programDetails.website,
        city: props.progressNoteData.programDetails.city,
        state: props.progressNoteData.programDetails.state,
        zipCode: props.progressNoteData.programDetails.zipCode,
      },
      clients: mapClientsData(props.progressNoteData.clients).map(
        (client, index) => {
          const existingClients = formikRef.current?.values.clients || [];

          if (existingClients[index]?.visits) {
            // Update only the `id` field of each visit while keeping other properties unchanged
            existingClients[index].visits = existingClients[index].visits.map(
              (visit, vIndex) => ({
                ...visit,
                id: client.visits[vIndex]?.id, // Update only the `id`
              }),
            );
          }
          if (isAddOrDeleteClientAction) {
            return client;
          }
          return index === openAccordianIndex
            ? client
            : existingClients[index] || client;
        },
      ),
    }));

    formikRef.current?.setValues(() => ({
      programDetails: {
        faxNumber: props.progressNoteData.programDetails.faxNumber,
        imageUrl:
          props.progressNoteData.programDetails.imageUrl !== ''
            ? props.progressNoteData.programDetails.imageUrl
            : ThomProgram,
        name: props.progressNoteData.programDetails.name,
        phoneNumber: props.progressNoteData.programDetails.phoneNumber,
        addressLine1: props.progressNoteData.programDetails.addressLine1,
        addressLine2: props.progressNoteData.programDetails.addressLine2,
        email: props.progressNoteData.programDetails.email,
        website: props.progressNoteData.programDetails.website,
        city: props.progressNoteData.programDetails.city,
        state: props.progressNoteData.programDetails.state,
        zipCode: props.progressNoteData.programDetails.zipCode,
      },
      clients: mapClientsData(props.progressNoteData.clients).map(
        (client, index) => {
          const existingClients = formikRef.current?.values.clients || [];

          if (existingClients[index]?.visits) {
            // Update only the `id` field of each visit while keeping other properties unchanged
            existingClients[index].visits = existingClients[index].visits.map(
              (visit, vIndex) => ({
                ...visit,
                id: client.visits[vIndex]?.id, // Update only the `id`
              }),
            );
          }
          if (isAddOrDeleteClientAction) {
            return client;
          }
          return index === openAccordianIndex
            ? client
            : existingClients[index] || client;
        },
      ),
    }));

    if (props.progressNoteData.clients.some((item) => item.isSelected)) {
      setSelectedClient(
        props.progressNoteData.clients
          .filter((item) => item.isSelected)
          .map((item) => ({
            progressNoteId: item.progressNoteId ? item.progressNoteId : '',
            clientId: item.client.clientId,
            clientName: formatName(
              item.client.firstName,
              item.client.middleName,
              item.client.lastName,
              item.client.suffix,
            ),
            isSelected: true,
          })),
      );

      setClientCheckList(
        props.progressNoteData.clients.map((item) => ({
          progressNoteId: item.progressNoteId ? item.progressNoteId : '',
          clientId: item.client.clientId,
          clientName: formatName(
            item.client.firstName,
            item.client.middleName,
            item.client.lastName,
            item.client.suffix,
          ),
          isSelected: item.isSelected,
        })),
      );

      setClientCheckListInitial(
        props.progressNoteData.clients.map((item) => ({
          progressNoteId: item.progressNoteId ? item.progressNoteId : '',
          clientId: item.client.clientId,
          clientName: formatName(
            item.client.firstName,
            item.client.middleName,
            item.client.lastName,
            item.client.suffix,
          ),
          isSelected: item.isSelected,
        })),
      );

      setClientCount(props.progressNoteData.clients.length);
    }

    setIsAddOrDeleteClientAction(false);
    setOpenAccordian(true);
  }, [props.progressNoteData]);

  const handelCoTreatmentDuration = (index: number, value?: boolean) => {
    setStartDuration(-1);
    setEndDuration(-1);
    formikRef.current?.setFieldValue(
      'clients',
      formikRef.current?.values.clients.map((client, idx) => {
        if (idx === openAccordianIndex) {
          let totalCoTx = 0;
          let totalIndividual = 0;

          client.visits.forEach((visit) => {
            const visitDuration = visit.durationDec ?? 0;

            if (visit.coTx) {
              totalCoTx += visitDuration;
            } else {
              totalIndividual += visitDuration;
            }
          });

          totalCoTx = parseFloat(totalCoTx.toFixed(2));
          totalIndividual = parseFloat(totalIndividual.toFixed(2));

          return {
            ...client,
            coTreatmentHrsDec: totalCoTx,
            individualHrsDec: totalIndividual,
            visits: client.visits.map((visit, i) => {
              if (i === index) {
                return {
                  ...visit,
                  coTx: value,
                };
              }
              return visit;
            }),
          };
        }
        return client;
      }),
    );
  };

  const checkProgressNoteAndActivitySheetStatus = (
    item: ProgressNoteClient,
  ) => {
    return (
      (item.status === 'Completed' || item.status === 'Canceled') &&
      item.activitySheetStatus !== 'Approved' &&
      progressNotePermission.canEdit
    );
  };

  useEffect(() => {
    handelCoTreatmentDuration(
      durationClickedIndex,
      formikRef.current?.values.clients[openAccordianIndex].visits[
        durationClickedIndex
      ]?.coTx,
    );
  }, [
    startDuration,
    endDuration,
    initialData?.clients[openAccordianIndex]?.visits,
    formikRef.current?.values.clients[openAccordianIndex]?.visits[
      durationClickedIndex
    ]?.durationDec,
  ]);

  const handleCloseSnakBar = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const closeDurationModal = () => {
    const status = initialData?.clients[openAccordianIndex].status;
    if ((status === 'In Progress' || status === 'Pending') && validUser) {
      turnOfMic();
    }
  };

  const onCancelClick = () => {
    setSignClicked(!signClicked);
  };

  const onSignatureSave = async (sign: string) => {
    setSignClicked(!signClicked);
    formikRef.current?.setFieldValue(
      'clients',
      formikRef.current?.values.clients.map((client, index) => {
        if (index === openAccordianIndex) {
          return {
            ...client,
            signature: {
              partitionKey: '',
              rowKey: '',
              signatureValue: sign,
            },
          };
        } else {
          return client;
        }
      }),
    );
  };

  const signatureCallBack = (response: SignatureStateType[]) => {
    formikRef.current?.setFieldValue(
      'clients',
      formikRef.current?.values.clients.map((client, index) => {
        if (index === openAccordianIndex) {
          return {
            ...client,
            signature: {
              partitionKey: response[0].partitionkey,
              rowKey: response[0].rowkey,
              signatureValue: response[0].signaturedata,
            },
          };
        } else {
          return client;
        }
      }),
    );
  };

  const viewEditorSignature = (
    log: ConsentClientSignature & {
      comment: string;
    },
  ) => {
    setHistorySignature({
      signature: log,
      open: true,
    });
  };

  const clearSignature = () => {
    formikRef.current?.setFieldValue(
      'clients',
      formikRef.current?.values.clients.map((client, index) => {
        if (index === openAccordianIndex) {
          let clientStatus = '';

          if (client.status === 'Pending') {
            clientStatus = 'Pending';
          } else if (client.status === 'In Progress') {
            clientStatus = 'In Progress';
          } else if (
            client.status === 'Canceled' &&
            client.visits[0].serviceCode.label !== ''
          ) {
            clientStatus = 'In Progress';
          } else if (
            client.status === 'Canceled' &&
            client.visits[0].serviceCode.label === ''
          ) {
            clientStatus = 'Pending';
          } else {
            clientStatus = 'In Progress';
          }
          return {
            ...client,
            status: clientStatus,
            signature: {
              name: null,
              date: null,
              partitionkey: '',
              rowkey: '',
              signatureValue: '',
            },
          };
        } else {
          return client;
        }
      }),
    );

    const programDetails = formikRef.current?.values.programDetails;
    const clients = formikRef.current?.values.clients;
    if (programDetails && clients) {
      setInitialData({
        programDetails: programDetails,
        clients: clients.map((client, index) => {
          if (index === openAccordianIndex) {
            let clientStatus: StatusType | null = null;

            if (client.status === 'Pending') {
              clientStatus = 'Pending';
            } else if (client.status === 'In Progress') {
              clientStatus = 'In Progress';
            } else if (client.status === 'Canceled') {
              clientStatus =
                client.visits[0].serviceCode.label !== ''
                  ? 'In Progress'
                  : 'Pending';
            } else {
              clientStatus = 'In Progress';
            }
            return {
              ...client,
              status: clientStatus,
              signature: {
                name: null,
                date: null,
                partitionkey: '',
                rowkey: '',
                signatureValue: '',
              },
            };
          } else {
            return client;
          }
        }),
      });
    }
    setOpen(true);
    setToastrVariable('success');
    setToastrId('ProgressNote.signatureResetedsuccess');
    setToastrDefaultMessage('Signature Reset Successfully');
    setSignClicked(!signClicked);
  };
  const handleSuccess = (successError: AlertColor, id: string, mes: string) => {
    setOpen(true);
    setToastrVariable(successError);
    setToastrId(id);
    setToastrDefaultMessage(mes);
  };

  const checkNoteEntered = () => {
    if (initialData && initialData.clients[0].notes.length > 8000) {
      setNoteError(true);
    } else {
      setNoteError(false);
    }
  };

  const getActivitySheetVisitStatus = (visit: ProgressNoteVisit) => {
    if (visit.onHold) {
      return 'On-hold';
    }
    return visit.activitySheetStatus ?? 'Not Submitted';
  };

  const validationSchema = yup.object().shape({
    clients: yup.array().of(
      yup.object().shape({
        clientIndex: yup.number(),
        notes: yup.string().when('clientIndex', {
          is: (clientIndex: number) =>
            clientIndex === openAccordianIndex && editClientIndex === null,
          then: yup.string().required('Note is required'),
          otherwise: yup.string(),
        }),
        selectedContacts: yup.array().of(yup.string()),
        individualHrsDec: yup.number().nullable(),
        coTreatementHrs: yup.string(),
        visits: yup.array().of(
          yup.object().shape({
            onHold: yup.boolean().nullable(),
            clientVisitsIndex: yup.number(),
            appointmentStage: yup
              .string()
              .when(['clientVisitsIndex', 'onHold'], {
                is: (clientVisitsIndex: number, onHold: boolean | null) =>
                  clientVisitsIndex === openAccordianIndex && !onHold,
                then: yup
                  .string()
                  .required('Appointment stage is required')
                  .nullable(),
                otherwise: yup.string().nullable(),
              }),
            clientLocationType: yup
              .string()
              .when(['clientVisitsIndex', 'onHold'], {
                is: (clientVisitsIndex: number, onHold: boolean | null) =>
                  clientVisitsIndex === openAccordianIndex && !onHold,
                then: yup
                  .string()
                  .required('Client location type is required')
                  .nullable(),
                otherwise: yup.string().nullable(),
              }),
            startTime: yup.string().when(['clientVisitsIndex', 'onHold'], {
              is: (clientVisitsIndex: number, onHold: boolean | null) =>
                clientVisitsIndex === openAccordianIndex && !onHold,
              then: yup
                .string()
                .required('Start time is required')
                .typeError('Start time is required'),
              otherwise: yup.string().nullable(),
            }),
            coTx: yup.boolean().nullable(),
            durationDec: yup.number().nullable(),
            serviceCode: yup.object().when(['clientVisitsIndex', 'onHold'], {
              is: (clientVisitsIndex: number, onHold: boolean | null) =>
                clientVisitsIndex === openAccordianIndex && !onHold,
              then: yup.object().shape({
                id: yup.string().required('Service code is required'),
                label: yup.string().required('Service label is required'),
              }),
              otherwise: yup.object().shape({
                id: yup.string(),
                label: yup.string(),
              }),
            }),
            settingCode: yup.object().when(['clientVisitsIndex', 'onHold'], {
              is: (clientVisitsIndex: number, onHold: boolean | null) =>
                clientVisitsIndex === openAccordianIndex && !onHold,
              then: yup.object().shape({
                id: yup.string().required('Setting code is required'),
                label: yup.string().required('Setting label is required'),
              }),
              otherwise: yup.object().shape({
                id: yup.string(),
                label: yup.string(),
              }),
            }),
            coTreatPartnerName: yup
              .array()
              .of(yup.string())
              .when(['clientVisitsIndex', 'coTx', 'onHold'], {
                is: (
                  clientVisitsIndex: number,
                  coTx: boolean,
                  onHold: boolean | null,
                ) =>
                  clientVisitsIndex === openAccordianIndex && coTx && !onHold,
                then: yup
                  .array()
                  .of(yup.string().min(1, 'Clinician is required'))
                  .min(1, 'Clinician is required')
                  .required('Clinician is required'),
                otherwise: yup.array().notRequired().nullable(), // <- skips all validation
              }),
            telehealth: yup.boolean().nullable(),
            telehealthType: yup
              .string()
              .when(['clientVisitsIndex', 'telehealth', 'onHold'], {
                is: (
                  clientVisitsIndex: number,
                  telehealth: string,
                  onHold: boolean | null,
                ) =>
                  clientVisitsIndex === openAccordianIndex &&
                  telehealth &&
                  !onHold,
                then: yup
                  .string()
                  .required('Telehealth type is required')
                  .nullable(),
                otherwise: yup.string().nullable(),
              }),
            providerLocationType: yup
              .string()
              .when(['clientVisitsIndex', 'telehealth', 'onHold'], {
                is: (
                  clientVisitsIndex: number,
                  telehealth: string,
                  onHold: boolean | null,
                ) =>
                  clientVisitsIndex === openAccordianIndex &&
                  telehealth &&
                  !onHold,
                then: yup
                  .string()
                  .required('Provider location type is required')
                  .nullable(),
                otherwise: yup.string().nullable(),
              }),
          }),
        ),
      }),
    ),
  });
  const handleClientSaveCheckList = () => {
    toggleLoader(true);
    CreateDeleteProgressNote(
      {
        clients: clientCheckList.map((item) => ({
          clientId: item.clientId,
          progressNoteId: item.progressNoteId,
          isSelected: item.isSelected,
        })),
      },
      props.clickedAttendeeId,
      props.progressNoteData.clients[openAccordianIndex].appointmentId,
      state ? state.referralProgramId : null,
    )
      .then(() => {
        setIsAddOrDeleteClientAction(true);
        setOpenAccordian(false);
        setOpenAccordianIndex(0);
        formikRef.current?.setTouched({}, false);
        setOpenClientModal(!openClientModal);
        setSelectedClient(clientCheckList.filter((item) => item.isSelected));
        props.triggerGetApi();
        setFirstEntry(false);
        setOpen(true);
        setToastrVariable('success');
        setToastrId('ProgressNoteCreatedSuccess');
        setToastrDefaultMessage('Progress note created successfully');
      })
      .catch((error) => {
        setOpen(true);
        setToastrVariable('error');
        toggleLoader(false);
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setToastrDefaultMessage(apiError.message);
        } else {
          setToastrId('ProgressNoteFailedToCreateError');
          setToastrDefaultMessage('Failed to create progress note');
        }
      });
  };

  const handleClientCancelCheckList = () => {
    if (firstEntry) {
      navigate(SCHEDULER_ROUTE_NAME, {
        state: {
          screenFrom: screenFrom,
        },
      });
    } else {
      setClientCheckList((prev) => {
        return prev.map((item) => {
          const isSelected = selectedClient.some(
            (client) => client.clientId === item.clientId,
          );
          return { ...item, isSelected };
        });
      });
      setOpenClientModal(false);
    }
  };

  useEffect(() => {
    if (selectedClient && selectedClient.length > 0 && initialData) {
      const updatedData = props.progressNoteData.clients.map((client) => {
        const matchingClient = selectedClient.find(
          (newClient) => newClient.clientId === client.client.clientId,
        );
        return matchingClient;
      });
      const updatedClients: ProgressNoteClient[] = [];
      let clientIndex: number;
      if (formikRef.current?.values?.clients === undefined) {
        updatedData.forEach((client) => {
          props.progressNoteData.clients.forEach((item) => {
            if (item.client.clientId === client?.clientId) {
              updatedClients.push({
                client: item.client,
                appointmentDate: item.appointmentDate,
                canceledReason: item.canceledReason,
                tpc: item.tpc,
                attendeeLicenseNo: item.attendeeLicenseNo,
                actualAppointmentTimeDec: item.actualAppointmentTimeDec,
                attendeeName: item.attendeeName,
                coTreatmentHrsDec: parseFloat(
                  (item.coTreatmentHrsDec ?? 0).toFixed(2),
                ),
                individualHrsDec:
                  item.individualHrsDec ?? item.visits[0].durationDec ?? 0,
                notes: item.notes,
                selectedContacts: item.selectedContacts,
                signature: item.signature,
                contact: item.contact,
                status: item.status,
                deletedVisitIds: item.deletedVisitIds,
                editedVisitIds: item.editedVisitIds,
                visits: item.visits.map((visit) => {
                  return {
                    id: visit.id,
                    coTx: visit.coTx,
                    asessmentHomeVisit: visit.asessmentHomeVisit,
                    clientLocationType: visit.clientLocationType,
                    ifspMeeting: visit.ifspMeeting,
                    supervisionCoTxHV: visit.supervisionCoTxHV,
                    appointmentStage:
                      visit.appointmentStage === '' ||
                      visit.appointmentStage === null
                        ? 'other'
                        : visit.appointmentStage,
                    startTime: visit.startTime,
                    durationDec: visit.durationDec,
                    serviceCode: visit.serviceCode,
                    settingCode: visit.settingCode,
                    coTreatPartnerName: visit.coTreatPartnerName,
                    activitySheetStatus: visit.activitySheetStatus,
                    telehealth: visit.telehealth,
                    telehealthType: visit.telehealthType,
                    providerLocationType: visit.providerLocationType,
                    onHold: visit.onHold,
                  };
                }),
                activitySheetStatus: item.activitySheetStatus,
                attendeeList: item.attendeeList,
                clientIndex: item.clientIndex,
                forms: item.forms,
                isSelected: item.isSelected,
                progressNoteId: item.progressNoteId,
                appointmentId: item.appointmentId,
                othersPresentInVisit: item.othersPresentInVisit,
                appointmentType: item.appointmentType,
                editorSignatures: item.editorSignatures,
                editorSignature: null,
              });
            }
          });
        });
      } else {
        const selectedIds = selectedClient.map((item) => item.clientId);
        selectedIds.forEach((id, index) => {
          const matchingClient = formikRef.current?.values?.clients.find(
            (client) => client.client.clientId === id,
          );
          if (matchingClient) {
            updatedClients.push(matchingClient);
          } else {
            clientIndex = props.progressNoteData.clients.findIndex(
              (item) => item.client.clientId === id,
            );
            updatedClients.push({
              client:
                clientIndex > -1
                  ? props.progressNoteData.clients[clientIndex].client
                  : props.progressNoteData.clients[index].client,
              deletedVisitIds:
                props.progressNoteData.clients[clientIndex].deletedVisitIds,
              editedVisitIds:
                props.progressNoteData.clients[clientIndex].editedVisitIds,
              visits: [
                {
                  id: '',
                  coTx: false,
                  asessmentHomeVisit: false,
                  ifspMeeting: false,
                  supervisionCoTxHV: false,
                  appointmentStage: 'other',
                  startTime: '',
                  clientLocationType: null,
                  durationDec:
                    props.progressNoteData.clients[clientIndex].visits[0]
                      .durationDec,
                  serviceCode: {
                    id: '',
                    label: '',
                  },
                  settingCode: {
                    id: '',
                    label: '',
                  },
                  coTreatPartnerName: [],
                  activitySheetStatus: 'Not Submitted',
                  telehealth: false,
                  telehealthType: null,
                  providerLocationType: null,
                  onHold: null,
                },
              ],
              selectedContacts: [],
              contact:
                clientIndex > -1
                  ? props.progressNoteData.clients[clientIndex].contact
                  : props.progressNoteData.clients[index].contact,
              attendeeList: props.progressNoteData.clients[0].attendeeList,
              actualAppointmentTimeDec:
                props.progressNoteData.clients[0].actualAppointmentTimeDec,
              canceledReason: {
                cancelReason: '',
                cancelReasonCode: '',
              },
              progressNoteId: '',
              isSelected: false,
              tpc: false,
              status: 'Pending',
              activitySheetStatus: 'Not Submitted',
              appointmentDate: '',
              appointmentId:
                props.progressNoteData.clients[clientIndex].appointmentId,
              appointmentType: '',
              othersPresentInVisit: '',
              individualHrsDec:
                props.progressNoteData.clients[clientIndex].visits[0]
                  .durationDec ?? 0,
              coTreatmentHrsDec: 0.0,
              forms: [],
              notes: '',
              attendeeLicenseNo: '',
              attendeeName: '',
              signature: {
                rowkey: '',
                partitionkey: '',
                signatureValue: '',
              },
              editorSignatures: [],
              editorSignature: null,
            });
          }
        });
      }

      setInitialData(() => ({
        programDetails: props.progressNoteData.programDetails,
        clients: updatedClients.map((client, index) => {
          return {
            ...client,
            clientIndex: index,
            visits: client.visits.map((visit, i) => ({
              ...visit,
              clientVisitsIndex: index,
              startTime:
                !validUser &&
                props.progressNoteData.clients.every((item) => !item.isSelected)
                  ? moment(
                      props.progressNoteData.clients[index]?.visits[i]
                        ?.startTime,
                      'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
                    )
                      .utc(true)
                      .local()
                      .format('HH:mm')
                  : visit.startTime,
            })),
          };
        }),
      }));
      formikRef.current?.setFieldValue(
        'clients',
        updatedClients.map((client, index) => ({
          ...client,
          clientIndex: index,
          visits: client.visits.map((visit, i) => ({
            ...visit,
            clientVisitsIndex: index,
            startTime:
              !validUser &&
              props.progressNoteData.clients.every((item) => !item.isSelected)
                ? moment(
                    props.progressNoteData.clients[index]?.visits[i]?.startTime,
                    'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
                  )
                    .utc(true)
                    .local()
                    .format('HH:mm')
                : visit.startTime,
          })),
        })),
      );
    }
  }, [selectedClient]);

  useEffect(() => {
    const settingCodeId =
      formikRef.current?.values.clients?.[openAccordianIndex]?.visits?.[
        currentVisitIndex
      ]?.settingCode?.id ?? '';

    const hasMatchingVisit = ['T02', '93', '95'].includes(settingCodeId);

    if (hasMatchingVisit) {
      formikRef.current?.setFieldValue(
        `clients[${openAccordianIndex}].visits.${currentVisitIndex}.telehealth`,
        true,
      );
    } else {
      formikRef.current?.setFieldValue(
        `clients[${openAccordianIndex}].visits.${currentVisitIndex}.telehealth`,
        false,
      );
      formikRef.current?.setFieldValue(
        `clients[${openAccordianIndex}].visits.${currentVisitIndex}.telehealthType`,
        null,
      );
      formikRef.current?.setFieldValue(
        `clients[${openAccordianIndex}].visits.${currentVisitIndex}.providerLocationType`,
        null,
      );
    }
  }, [settingChange, currentVisitIndex]);

  const handleClientCheckBoxClick = (e: boolean, id: string) => {
    setClientCheckList((prev) => {
      return prev.map((item) => {
        if (item.clientId === id) {
          return { ...item, isSelected: e };
        }
        return item;
      });
    });
  };

  const handlePDUpdatingPN = async () => {
    const newErrors = await formikRef.current?.validateForm();
    formikRef.current?.setTouched({
      clients: formikRef.current?.values.clients.map((__, idx) =>
        idx === openAccordianIndex
          ? {
              notes: true,
              visits: formikRef.current?.values.clients[idx].visits.map(() => ({
                startTime: true,
                serviceCode: {
                  id: true,
                  label: true,
                },
                settingCode: {
                  id: true,
                  label: true,
                },
                clientLocationType: true,
                coTreatPartnerName: true,
                telehealthType: true,
                providerLocationType: true,
              })),
            }
          : {},
      ),
    });
    if (!newErrors?.clients?.[openAccordianIndex]) {
      setEditSignClicked(true);
    }
  };

  const checkGroupBillingToDisableForFileds = () => {
    if (progressNotePermission.canEdit) return false;

    return (
      !validUser ||
      initialData?.clients[openAccordianIndex].activitySheetStatus ===
        'Submitted' ||
      initialData?.clients[openAccordianIndex].activitySheetStatus ===
        'Approved'
    );
  };

  const checkGroupBillingToDisableForAction = () => {
    if (progressNotePermission.canEdit) return true;

    return (
      validUser &&
      initialData?.clients[openAccordianIndex].activitySheetStatus !==
        'Submitted' &&
      initialData?.clients[openAccordianIndex].activitySheetStatus !==
        'Approved'
    );
  };

  const navigateTo = () => {
    if (screenFrom === 'EmployeeActivity') {
      if (props.progressNoteData?.clients[0]?.attendeeList) {
        const firstName =
          props.progressNoteData.clients[0].attendeeList[0]?.firstName;
        const lastName =
          props.progressNoteData.clients[0].attendeeList[0]?.lastName;
        navigate(ACTIVITY_SHEET_ROUTE_NAME, {
          state: {
            id: props.previousScreenAttendeeId,
            date: props.selectedDateInReviewActivityScreen,
            firstName: firstName,
            lastName: lastName,
          },
        });
      }
    } else if (screenFrom === 'ApprovalActivitySheet') {
      if (props.progressNoteData?.clients[0]?.attendeeList) {
        const firstName = props.progressNoteData.clients[0].attendeeList.find(
          (item) => item.attendeeId === props.previousScreenAttendeeId,
        )?.firstName;
        const lastName = props.progressNoteData.clients[0].attendeeList.find(
          (item) => item.attendeeId === props.previousScreenAttendeeId,
        )?.lastName;
        navigate(ACTIVITY_APPROVAL_SHEET_ROUTE_NAME, {
          state: {
            id: props.previousScreenAttendeeId,
            date: props.selectedDateInReviewActivityScreen,
            firstName: firstName,
            lastName: lastName,
            reviewActivityTab: 'billing',
          },
        });
      }
    } else if (screenFrom === 'schedulerEvent') {
      navigate(SCHEDULER_ROUTE_NAME, {
        state: {
          screenFrom: screenFrom,
        },
      });
    } else if (screenFrom === 'ProgressNoteList') {
      navigate(PROGRESS_NOTE_LIST_ROUTE_NAME);
    } else if (screenFrom === 'ProgressNoteFacesheet') {
      navigate(PROGRESS_NOTE_FACESHEET);
    } else {
      history.back();
    }
  };

  const enableSaveButton = (item: ProgressNoteClient) => {
    if (editClientIndex === null) {
      return (
        item.activitySheetStatus !== 'Submitted' &&
        item.activitySheetStatus !== 'Approved'
      );
    }
    return true;
  };

  const handleOnSubmit = debounce(
    async (value: ProgressNoteType, byPassServiceCode: boolean) => {
      if (value.clients?.[openAccordianIndex].canceledReason?.cancelReason) {
        setIsScreenLocked(true);
      } else {
        setIsScreenLocked(false);
      }
      const localAppointmentDateToUtc = moment(
        `${localAppointmentDate} ${localAppointmentTime}`,
        'MM/DD/YYYY hh:mm',
      )
        .utc()
        .format('YYYY-MM-DDTHH:mm');

      let editorSignatureValue: ProgressNoteSignature | null = null;
      if (
        editClientIndex !== null &&
        editPayloadRef.current.comments &&
        editPayloadRef.current.signatureValue
      ) {
        editorSignatureValue = {
          userId: getLocalStorageItem(STORAGE_USER_ID_KEY),
          firstName: getLocalStorageItem(STORAGE_USERFIRSTNAME_KEY),
          lastName: getLocalStorageItem(STORAGE_USERLASTNAME_KEY),
          middleName: '',
          name: getLocalStorageItem(STORAGE_USERNAME_KEY),
          date: dayjs().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
          email: '',
          comment: editPayloadRef.current.comments,
          signature: editPayloadRef.current.signatureValue,
        };
      }

      const originalVisits =
        origainalInitialData?.clients?.[openAccordianIndex]?.visits || [];

      const currentVisits = value?.clients?.[openAccordianIndex]?.visits || [];

      let isAnyDurationChanged = false;
      let isAnyChangeApartFromDuration = false;

      currentVisits.forEach((visit, index) => {
        const originalVisit = originalVisits[index];

        for (const property of propertiesToCheckInVisits) {
          if (!_.isEqual(originalVisit?.[property], visit?.[property])) {
            isAnyChangeApartFromDuration = true;
            break;
          }
        }

        if (!_.isEqual(originalVisit?.durationDec, visit?.durationDec)) {
          isAnyDurationChanged = true;
        }
      });

      const hasMultipleClients = selectedClient.length > 1;

      const billingModified = hasMultipleClients
        ? isAnyChangeApartFromDuration
        : isAnyDurationChanged || isAnyChangeApartFromDuration;

      const payrollModified = hasMultipleClients ? false : isAnyDurationChanged;

      const editedVisitsIds: string[] = currentVisits.reduce(
        (ids, visit, index) => {
          if (
            visit.id &&
            visit.id === originalVisits[index]?.id &&
            !_.isEqual(visit, originalVisits[index])
          ) {
            ids.push(visit.id);
          }

          return ids;
        },
        [] as string[],
      );

      const paramsData: ProgressNoteType = {
        clients: [
          {
            client: value.clients[openAccordianIndex].client,
            status: (() => {
              const hasSignature =
                value.clients[openAccordianIndex].signature.signatureValue !==
                '';
              const hasCancelReason =
                value.clients[openAccordianIndex].canceledReason
                  ?.cancelReason !== '';

              if (hasSignature && hasCancelReason) return 'Canceled';
              if (hasSignature && !hasCancelReason) return 'Completed';
              return 'In Progress';
            })(),
            appointmentDate: localAppointmentDateToUtc,
            appointmentId: value.clients[openAccordianIndex].appointmentId,
            progressNoteId: value.clients[openAccordianIndex].progressNoteId,
            appointmentType: value.clients[openAccordianIndex].appointmentType,
            othersPresentInVisit:
              value.clients[openAccordianIndex].othersPresentInVisit,
            actualAppointmentTimeDec:
              value.clients[openAccordianIndex].actualAppointmentTimeDec,
            individualHrsDec:
              value.clients[openAccordianIndex].individualHrsDec,
            tpc: value.clients[openAccordianIndex].tpc,
            coTreatmentHrsDec:
              value.clients[openAccordianIndex].coTreatmentHrsDec,
            activitySheetStatus:
              value.clients[openAccordianIndex].activitySheetStatus,
            deletedVisitIds: value.clients[openAccordianIndex].deletedVisitIds,
            editedVisitIds: editedVisitsIds || [],
            visits: value.clients[openAccordianIndex].visits.map((visit) => ({
              id: visit.id,
              appointmentStage: visit.appointmentStage,
              coTx: visit.coTx,
              clientLocationType: visit.clientLocationType,
              asessmentHomeVisit: visit.asessmentHomeVisit,
              ifspMeeting: visit.ifspMeeting,
              supervisionCoTxHV: visit.supervisionCoTxHV,
              startTime: moment(
                `${localAppointmentDate} ${visit.startTime}`,
                'MM/DD/YYYY HH:mm',
              )
                .utc()
                .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
              durationDec: visit.durationDec,
              serviceCode: visit.serviceCode,
              settingCode: visit.settingCode,
              coTreatPartnerName: visit.coTreatPartnerName,
              activitySheetStatus: visit.activitySheetStatus,
              telehealth: visit.telehealth,
              telehealthType: visit.telehealthType,
              onHold: visit.onHold,
              providerLocationType: visit.providerLocationType,
            })),
            billingModified:
              value.clients[openAccordianIndex].activitySheetStatus ===
                'Submitted' && billingModified,
            payrollModified:
              value.clients[openAccordianIndex].activitySheetStatus ===
                'Submitted' && payrollModified,
            selectedContacts:
              value.clients[openAccordianIndex].selectedContacts,
            contact: value.clients[openAccordianIndex].contact,
            canceledReason: value.clients[openAccordianIndex].canceledReason,
            notes: value.clients[openAccordianIndex].notes,
            signature: {
              partitionkey:
                value.clients[openAccordianIndex].signature.partitionkey,
              rowkey: value.clients[openAccordianIndex].signature.rowkey,
              signatureValue:
                value.clients[openAccordianIndex].signature.signatureValue,
            },
            attendeeName: value.clients[openAccordianIndex].attendeeName,
            attendeeLicenseNo:
              value.clients[openAccordianIndex].attendeeLicenseNo,
            attendeeList: value.clients[openAccordianIndex].attendeeList,
            editorSignature: editorSignatureValue,
            editorSignatures:
              value.clients[openAccordianIndex].editorSignatures,
            isSelected: value.clients[openAccordianIndex].isSelected,
            commonAppointmentId:
              value.clients[openAccordianIndex].commonAppointmentId,
          },
        ],
        programDetails: value.programDetails,
      };

      if (!noteError) {
        toggleLoader(true);
        EditProgressNote(
          paramsData,
          props.clickedAttendeeId,
          props.eventId,
          byPassServiceCode,
          state ? state.referralProgramId : null,
        )
          .then((response) => {
            if (response.showPopup) {
              setServiceCodes({
                showModal: response.showPopup,
                visits: response.visits,
              });
            } else {
              setServiceCodes(undefined);
              setOpen(true);
              setToastrVariable('success');
              setToastrId('ProgressNote.savedsuccess');
              setToastrDefaultMessage('Data Saved Successfully');
              formikRef.current?.setValues(() => ({
                programDetails: {
                  faxNumber: props.progressNoteData.programDetails.faxNumber,
                  imageUrl:
                    props.progressNoteData.programDetails.imageUrl !== ''
                      ? props.progressNoteData.programDetails.imageUrl
                      : ThomProgram,
                  name: props.progressNoteData.programDetails.name,
                  phoneNumber:
                    props.progressNoteData.programDetails.phoneNumber,
                  addressLine1:
                    props.progressNoteData.programDetails.addressLine1,
                  addressLine2:
                    props.progressNoteData.programDetails.addressLine2,
                  email: props.progressNoteData.programDetails.email,
                  website: props.progressNoteData.programDetails.website,
                  city: props.progressNoteData.programDetails.city,
                  state: props.progressNoteData.programDetails.state,
                  zipCode: props.progressNoteData.programDetails.zipCode,
                },
                clients: value.clients.map((client, index) => {
                  if (index === openAccordianIndex) {
                    return {
                      ...client,
                      deletedVisitIds: [],
                    };
                  }
                  return client;
                }),
              }));
              setInitialData(() => ({
                programDetails: {
                  faxNumber: props.progressNoteData.programDetails.faxNumber,
                  imageUrl:
                    props.progressNoteData.programDetails.imageUrl !== ''
                      ? props.progressNoteData.programDetails.imageUrl
                      : ThomProgram,
                  name: props.progressNoteData.programDetails.name,
                  phoneNumber:
                    props.progressNoteData.programDetails.phoneNumber,
                  addressLine1:
                    props.progressNoteData.programDetails.addressLine1,
                  addressLine2:
                    props.progressNoteData.programDetails.addressLine2,
                  email: props.progressNoteData.programDetails.email,
                  website: props.progressNoteData.programDetails.website,
                  city: props.progressNoteData.programDetails.city,
                  state: props.progressNoteData.programDetails.state,
                  zipCode: props.progressNoteData.programDetails.zipCode,
                },
                clients: value.clients.map((client, index) => {
                  if (index === openAccordianIndex) {
                    return {
                      ...client,
                      deletedVisitIds: [],
                      status: (() => {
                        const c = value.clients[openAccordianIndex];
                        const hasSignature = c.signature.signatureValue !== '';
                        const hasCancelReason =
                          c.canceledReason?.cancelReason !== '';

                        if (hasSignature && hasCancelReason) return 'Canceled';
                        return hasSignature && !hasCancelReason
                          ? 'Completed'
                          : 'In Progress';
                      })(),
                    };
                  }
                  return client;
                }),
              }));
              if (
                formikRef.current?.values.clients &&
                formikRef.current?.values.clients.length > 1 &&
                formikRef.current?.values.clients[openAccordianIndex]
                  .canceledReason?.cancelReason !== '' &&
                formikRef.current?.values.clients[openAccordianIndex].signature
                  .signatureValue !== ''
              ) {
                setOpenAccordian(false);
              }
            }
            if (!response.showPopup) {
              props.triggerGetApi();
            } else {
              toggleLoader(false);
            }
          })
          .catch((error) => {
            setOpen(true);
            setToastrVariable('error');
            toggleLoader(false);
            if (isCustomError(error)) {
              const apiError = error as ApiError;
              setToastrId(apiError.id);
              setToastrDefaultMessage(apiError.message);
            } else {
              const response = error as ApiMessage;
              if (response.code === 1013) {
                setToastrDefaultMessage(response.message);
                setToastrId('ProgressNote.NoAppointmentError');
                setTimeout(navigateTo, 2000);
              } else if (response.code === 1012) {
                setToastrDefaultMessage(response.message);
                setToastrId('ProgressNote.NoAttendeeError');
                setTimeout(navigateTo, 2000);
              } else if (response.code === 1055) {
                setToastrDefaultMessage(response.message);
                setToastrId('ProgressNote.EnrollmentIdError');
              } else if (response.code === 1010) {
                setToastrDefaultMessage(response.message);
                setToastrId('ProgressNote.NoClientError');
                setTimeout(navigateTo, 2000);
              } else if (response.code === 1062) {
                setToastrDefaultMessage(response.message);
                setToastrId('ProgressNote.IfspNotCompleted');
              } else if (response.code === 1095) {
                setToastrDefaultMessage(response.message);
                setToastrId('ProgressNote.WaiverInsufficient');
              } else if (response.code === 1096) {
                setToastrDefaultMessage(response.message);
                setToastrId('ProgressNote.WaiverInsufficient');
                setTimeout(navigateTo, 3000);
              } else if (response.code === 1103) {
                setToastrDefaultMessage(response.message);
                setToastrId(
                  'ProgressNote.WaiverNotAppliedToAllServiceCodeMessage',
                );
              } else if (response.code === 1117) {
                setToastrDefaultMessage(response.message);
                setToastrId('ProgressNote.ClientLocationRequired');
              } else if (response.code === 1190) {
                setToastrDefaultMessage(response.message);
                setToastrId(
                  'ProgressNote.ActionDeniedReferralClosedAndDischarged',
                );
              } else {
                setToastrId('ProgressNote.err');
                setToastrDefaultMessage(response.message);
              }
            }
          });
      }
    },
    500,
    { leading: true, trailing: false },
  );

  const handlePendingSubmit = debounce(
    (value: ProgressNoteType) => {
      toggleLoader(true);
      const clientData = value.clients[openAccordianIndex];

      setIsScreenLocked(clientData.canceledReason?.cancelReason !== '');

      const filteredInitialPendingData = props.progressNoteData.clients.filter(
        (data) => data.client.clientId === clientData.client.clientId,
      );

      if (filteredInitialPendingData.length === 0) {
        toggleLoader(false);
        return;
      }

      let editorSignatureValue: ProgressNoteSignature | null = null;
      if (
        editClientIndex !== null &&
        editPayloadRef.current.comments &&
        editPayloadRef.current.signatureValue
      ) {
        editorSignatureValue = {
          userId: getLocalStorageItem(STORAGE_USER_ID_KEY),
          firstName: getLocalStorageItem(STORAGE_USERFIRSTNAME_KEY),
          lastName: getLocalStorageItem(STORAGE_USERLASTNAME_KEY),
          middleName: '',
          name: getLocalStorageItem(STORAGE_USERNAME_KEY),
          date: dayjs().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
          email: '',
          comment: editPayloadRef.current.comments,
          signature: editPayloadRef.current.signatureValue,
        };
      }

      const originalClientData = filteredInitialPendingData[0];

      const paramsData: ProgressNoteType = {
        clients: [
          {
            client: { ...originalClientData.client },
            status: (() => {
              const hasSignature = clientData.signature.signatureValue !== '';
              const hasCancelReason =
                clientData.canceledReason?.cancelReason !== '';

              if (hasSignature && hasCancelReason) return 'Canceled';
              if (hasSignature) return 'Completed';
              return 'Pending';
            })(),
            appointmentDate: originalClientData.appointmentDate,
            appointmentId: originalClientData.appointmentId,
            progressNoteId: originalClientData.progressNoteId,
            appointmentType: originalClientData.appointmentType,
            othersPresentInVisit: originalClientData.othersPresentInVisit,
            actualAppointmentTimeDec:
              originalClientData.actualAppointmentTimeDec,
            individualHrsDec: originalClientData.individualHrsDec,
            coTreatmentHrsDec: originalClientData.coTreatmentHrsDec,
            activitySheetStatus: originalClientData.activitySheetStatus,

            tpc: originalClientData.tpc,

            deletedVisitIds: originalClientData.deletedVisitIds,
            editedVisitIds: originalClientData.editedVisitIds,
            visits: originalClientData.visits.map((visit) => ({
              id: visit.id,
              appointmentStage: visit.appointmentStage,
              coTx: visit.coTx,
              clientLocationType: visit.clientLocationType,
              asessmentHomeVisit: visit.asessmentHomeVisit,
              supervisionCoTxHV: visit.supervisionCoTxHV,
              ifspMeeting: visit.ifspMeeting,
              startTime: visit.startTime,
              durationDec: visit.durationDec,
              serviceCode: visit.serviceCode,
              settingCode: visit.settingCode,
              coTreatPartnerName: visit.coTreatPartnerName,
              activitySheetStatus: visit.activitySheetStatus,
              telehealth: visit.telehealth,
              telehealthType: visit.telehealthType,
              providerLocationType: visit.providerLocationType,
              onHold: visit.onHold,
            })),
            selectedContacts: originalClientData.selectedContacts,
            contact: originalClientData.contact,
            canceledReason: clientData.canceledReason,
            notes: clientData.notes,
            signature: clientData.signature,
            attendeeName: originalClientData.attendeeName,
            attendeeLicenseNo: originalClientData.attendeeLicenseNo,
            attendeeList: originalClientData.attendeeList,
            editorSignature: editorSignatureValue,
            editorSignatures: originalClientData.editorSignatures,
            isSelected: originalClientData.isSelected,
            commonAppointmentId: originalClientData.commonAppointmentId,
          },
        ],
        programDetails: value.programDetails,
      };

      EditProgressNote(
        paramsData,
        props.clickedAttendeeId,
        props.eventId,
        false,
        state ? state.referralProgramId : null,
      )
        .then((response) => {
          if (response.showPopup) {
            setServiceCodes({
              showModal: response.showPopup,
              visits: response.visits,
            });
          } else {
            setInitialData({
              programDetails: value.programDetails,
              clients: value.clients.map((client, index) => {
                if (
                  index === openAccordianIndex &&
                  formikRef.current?.initialValues
                ) {
                  return {
                    ...formikRef.current?.initialValues.clients[
                      openAccordianIndex
                    ],
                    notes: clientData.notes,
                    canceledReason: clientData.canceledReason,
                    signature:
                      clientData.status === 'Pending' &&
                      clientData.canceledReason?.cancelReason === ''
                        ? {
                            partitionkey: '',
                            rowkey: '',
                            signatureValue: '',
                          }
                        : clientData.signature,
                    visits: originalClientData.visits.map((visit) => ({
                      ...visit,
                      appointmentStage: visit.appointmentStage,
                      coTx: visit.coTx,
                      asessmentHomeVisit: visit.asessmentHomeVisit,
                      supervisionCoTxHV: visit.supervisionCoTxHV,
                      ifspMeeting: visit.ifspMeeting,
                      startTime: moment(
                        visit.startTime,
                        'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
                      )
                        .utc(true)
                        .local()
                        .format('HH:mm'),
                      serviceCode: visit.serviceCode,
                      settingCode: visit.settingCode,
                      coTreatPartnerName: visit.coTreatPartnerName,
                      telehealth: visit.telehealth,
                      telehealthType: visit.telehealthType,
                      providerLocationType: visit.providerLocationType,
                      onHold: visit.onHold,
                    })),
                    status: (() => {
                      const hasSignature =
                        clientData.signature.signatureValue !== '';
                      const hasCancelReason =
                        clientData.canceledReason?.cancelReason !== '';

                      if (hasSignature && hasCancelReason) return 'Canceled';
                      if (hasSignature) return 'Completed';
                      return 'Pending';
                    })(),
                  };
                } else {
                  return client;
                }
              }),
            });

            formikRef.current?.setFieldValue(
              'clients',
              formikRef.current?.values.clients.map((client, index) => {
                if (index === openAccordianIndex) {
                  return {
                    ...formikRef.current?.initialValues.clients[
                      openAccordianIndex
                    ],
                    notes: clientData.notes,
                    canceledReason: clientData.canceledReason,
                    signature:
                      clientData.status === 'Pending' &&
                      clientData.canceledReason?.cancelReason === ''
                        ? {
                            partitionkey: '',
                            rowkey: '',
                            signatureValue: '',
                          }
                        : clientData.signature,
                    visits: originalClientData.visits.map((visit) => ({
                      ...visit,
                      appointmentStage: visit.appointmentStage,
                      coTx: visit.coTx,
                      startTime: moment(
                        visit.startTime,
                        'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
                      )
                        .utc(true)
                        .local()
                        .format('HH:mm'),
                      serviceCode: visit.serviceCode,
                      settingCode: visit.settingCode,
                      telehealth: visit.telehealth,
                      telehealthType: visit.telehealthType,
                      providerLocationType: visit.providerLocationType,
                      onHold: visit.onHold,
                    })),
                    status: (() => {
                      const hasSignature =
                        clientData.signature.signatureValue !== '';
                      const hasCancelReason =
                        clientData.canceledReason?.cancelReason !== '';

                      if (hasSignature && hasCancelReason) return 'Canceled';
                      if (hasSignature) return 'Completed';
                      return 'Pending';
                    })(),
                  };
                } else {
                  return client;
                }
              }),
            );
            setOpen(true);
            setToastrVariable('success');
            setToastrId('ProgressNote.savedsuccess');
            setToastrDefaultMessage('Data Saved Successfully');
          }
          props.triggerGetApi();
        })
        .catch((error) => {
          setOpen(true);
          setToastrVariable('error');
          toggleLoader(false);
          if (isCustomError(error)) {
            const apiError = error as ApiError;
            setToastrId(apiError.id);
            setToastrDefaultMessage(apiError.message);
          } else {
            const response = error as ApiMessage;
            if (response.code === 1013) {
              setToastrDefaultMessage(response.message);
              setToastrId('ProgressNote.NoAppointmentError');
              setTimeout(navigateTo, 2000);
            } else if (response.code === 1012) {
              setToastrDefaultMessage(response.message);
              setToastrId('ProgressNote.NoAttendeeError');
              setTimeout(navigateTo, 2000);
            } else if (response.code === 1010) {
              setToastrDefaultMessage(response.message);
              setToastrId('ProgressNote.NoClientError');
              setTimeout(navigateTo, 2000);
            } else if (response.code === 1081) {
              setToastrId('ApiError.InsufficientAssessmentHrs');
              setToastrDefaultMessage(
                'Insufficient assessment hours. Please use service codes other than TG and TH to complete your progress notes.',
              );
            } else if (response.code === 1083) {
              setToastrId('ApiError.AppointmentCannotBePriorToVisitDate');
              setToastrDefaultMessage(
                'This Appointment cannot be prior to First Visit Date',
              );
            } else if (response.code === 1062) {
              setToastrDefaultMessage(response.message);
              setToastrId('ProgressNote.IfspNotCompleted');
              setTimeout(navigateTo, 3000);
            } else if (response.code === 1103) {
              setToastrDefaultMessage(response.message);
              setToastrId(
                'ProgressNote.WaiverNotAppliedToAllServiceCodeMessage',
              );
            } else if (response.code === 1190) {
              setToastrDefaultMessage(response.message);
              setToastrId(
                'ProgressNote.ActionDeniedReferralClosedAndDischarged',
              );
            } else {
              setToastrId('ProgressNote.err');
              setToastrDefaultMessage(response.message);
            }
          }
        });
    },
    500,
    { leading: true, trailing: false },
  );

  const addVisit = () => {
    const newVisit: ProgressNoteVisit = {
      appointmentStage: 'other',
      clientLocationType: null,
      durationDec: 0,
      coTx: false,
      coTreatPartnerName: [],
      asessmentHomeVisit: false,
      ifspMeeting: false,
      supervisionCoTxHV: false,
      clientVisitsIndex: openAccordianIndex,
      serviceCode: {
        id: '',
        label: '',
      },
      settingCode: {
        id: '',
        label: '',
      },
      telehealth: false,
      telehealthType: null,
      providerLocationType: null,
      startTime:
        origainalInitialData?.clients[openAccordianIndex].visits[0].startTime ??
        '',
      onHold: false,
      id: '',
      activitySheetStatus: null,
    };
    // Update form values directly
    formikRef.current?.setFieldValue(
      'clients',
      formikRef.current?.values.clients.map((client, index) => {
        if (index === openAccordianIndex) {
          return {
            ...client,
            visits: [...client.visits, newVisit],
          };
        }
        return client;
      }),
    );
    if (initialData) {
      setInitialData({
        ...initialData,
        clients: initialData.clients.map((client, index) => {
          if (index === openAccordianIndex) {
            return {
              ...client,
              visits: [
                ...client.visits,
                {
                  id: '',
                  appointmentStage: '',
                  durationDec: null,
                  clientLocationType: null,
                  coTx: false,
                  asessmentHomeVisit: false,
                  ifspMeeting: false,
                  supervisionCoTxHV: false,
                  clientVisitsIndex: openAccordianIndex,
                  serviceCode: {
                    id: '',
                    label: '',
                  },
                  settingCode: {
                    id: '',
                    label: '',
                  },
                  coTreatPartnerName: [],
                  telehealth: false,
                  telehealthType: null,
                  providerLocationType: null,
                  startTime: '',
                  activitySheetStatus: 'Not Submitted',
                  onHold: null,
                },
              ],
            };
          }
          return client;
        }),
      });
    }
  };
  const deleteVisit = (index: number, visitsId: string) => {
    formikRef.current?.setFieldValue(
      'clients',
      formikRef.current?.values.clients.map((client, clientIndex) => {
        if (clientIndex === openAccordianIndex) {
          return {
            ...client,
            deletedVisitIds: visitsId
              ? [...client.deletedVisitIds, visitsId]
              : [...client.deletedVisitIds],
            visits: client.visits.filter((__, i) => i !== index),
          };
        }
        return client;
      }),
    );
    if (initialData) {
      setInitialData({
        ...initialData,
        clients: initialData.clients.map((client, clientIndex) => {
          if (clientIndex === openAccordianIndex) {
            return {
              ...client,
              visits: client.visits.filter((__, i) => i !== index),
            };
          }
          return client;
        }),
      });
    }
  };

  const handleDownload = (
    selectedClientId: string,
    attendeeId: string,
    appointmentId: string,
    language: string,
  ) => {
    toggleLoader(true);
    const localTimezone = dayjs.tz.guess();
    downloadProgressNote(
      selectedClientId,
      attendeeId,
      appointmentId,
      localTimezone,
      state ? state.referralProgramId : null,
      language,
    )
      .then((response) => {
        const blob = new Blob([response], { type: 'application/pdf' });

        // Create a Blob URL
        const blobUrl = URL.createObjectURL(blob);

        // Open the Blob URL in a new tab
        const anchor = document.createElement('a');
        anchor.href = blobUrl;
        anchor.target = '_blank';
        const downloadClient = props.progressNoteData.clients.find(
          (item) => item.client.clientId === selectedClientId,
        );
        anchor.download = getClientDocumentFileName(
          'ProgressNotes.pdf',
          downloadClient?.appointmentDate
            ? moment(downloadClient.appointmentDate, 'YYYY-MM-DDTHH:mm')
                .utc(true)
                .local()
                .format('MM/DD/YYYY')
            : null,
          {
            enrollmentId: downloadClient?.client.dphId,
            firstName: downloadClient?.client.firstName,
            lastName: downloadClient?.client.lastName,
          },
        ); // Set desired file name here

        // Append anchor to document body
        document.body.appendChild(anchor);

        // Trigger anchor click
        anchor.click();

        window.open(blobUrl, '_blank');

        // Clean up after use
        URL.revokeObjectURL(blobUrl);
        document.body.removeChild(anchor);

        toggleLoader(false);
      })
      .catch((error) => {
        toggleLoader(false);
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setToastrDefaultMessage(apiError.message);
        } else {
          setToastrId('ConsentForms.downloadErrorMsg');
          setToastrDefaultMessage('Failed to download');
        }
      });
  };

  const handleCloseCancelVisit = () => {
    formikRef.current?.setTouched({}, false);
    setOpenCancelVisitModal(false);
  };

  // New helper function
  const handleFormSubmission = () => {
    const hasCanceledPendingReason =
      formikRef?.current?.values.clients[openAccordianIndex].canceledReason
        ?.cancelReason &&
      formikRef.current.values.clients[openAccordianIndex].status === 'Pending';

    if (editClientIndex !== null && hasCanceledPendingReason) {
      // PD editing with canceled+pending - skip validation, directly open PIN
      setEditSignClicked(true);
    } else if (editClientIndex !== null) {
      // PD editing normally - validate then open PIN
      handlePDUpdatingPN();
    } else if (hasCanceledPendingReason) {
      // Normal user with canceled+pending - direct submit without PIN
      handlePendingSubmit(formikRef.current.values);
    } else {
      // Normal submission
      turnOfMic();
      checkNoteEntered();
      formikRef.current?.submitForm();
    }
  };
  const getClientStatus = (client: ProgressNoteClient): string => {
    const serviceLabel = client.visits[0].serviceCode.label;

    if (client.status === 'Pending') {
      return 'Pending';
    }

    if (client.status === 'In Progress') {
      return 'In Progress';
    }

    if (client.status === 'Canceled') {
      return serviceLabel !== '' ? 'In Progress' : 'Pending';
    }

    return 'In Progress';
  };
  const handelLockScreen = (reason: OptionType) => {
    formikRef.current?.setFieldValue(
      'clients',
      formikRef.current?.values.clients.map((client, index) => {
        if (index === openAccordianIndex) {
          return {
            ...client,
            canceledReason: {
              cancelReasonCode: reason.id,
              cancelReason: reason.label,
            },
            status: getClientStatus(client),
          };
        }
        return client;
      }),
    );
    setIsScreenLocked(true);
    setTimeout(() => {
      handleFormSubmission();
    }, 0);
  };

  const showCancelToaster = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          position: 'absolute',
          maxWidth: 'max-content',
          width: '100%',
          marginTop: '100px',
          justifyContent: 'center',
          alignSelf: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            backgroundColor: '#EB4C60',
            width: '100%',
            padding: '24px 32px 24px 32px',
            borderRadius: '60px',
            justifyContent: 'center',
          }}
        >
          <Box sx={{ paddingTop: '3px' }}>
            <StopWhite />
          </Box>
          <Box>
            <MediumTypography
              textColor="#FFFFFF"
              sxProps={{ marginLeft: '8px' }}
              label={`This Progress Note is Canceled due to ${formikRef.current?.values.clients[openAccordianIndex].canceledReason?.cancelReason}`}
            />
          </Box>
        </Box>
        {(formikRef.current?.values.clients[openAccordianIndex].signature
          .rowkey === '' ||
          formikRef.current?.values.clients[openAccordianIndex].signature
            .signatureValue === '') &&
          validUser &&
          initialData?.clients[openAccordianIndex].activitySheetStatus !==
            'Submitted' &&
          initialData?.clients[openAccordianIndex].activitySheetStatus !==
            'Approved' && (
            <Box
              sx={{
                display: 'flex',
                paddingY: '4px',
                paddingX: '12px',
                marginTop: '16px',
                columnGap: '8px',
                pointerEvents: 'auto',
                backgroundColor: '#FFFFFF',
                borderRadius: '4px',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
              className="cursorPointer"
              onClick={handleUndoVisit}
            >
              <Undo />
              <MediumTypography
                labelid="ProgressNote.Undo"
                defaultlabel="Undo"
                textColor="#97A6A5"
                fontSize="14px"
                textstyle="center"
                fontweight={600}
              />
            </Box>
          )}
      </Box>
    );
  };

  const handleUndoVisit = () => {
    setIsScreenLocked(false);
    formikRef.current?.setFieldValue(
      'clients',
      formikRef.current?.values.clients.map((client, index) => {
        if (index === openAccordianIndex) {
          return {
            ...client,
            status: getClientStatus(client),
            canceledReason: {
              cancelReasonCode: '',
              cancelReason: '',
            },
            cancelReason: '',
            signature: {
              partitionKey: '',
              rowKey: '',
              signatureValue: '',
              partitionkey: '',
            },
          };
        }
        return client;
      }),
    );
    setTimeout(() => {
      if (
        formikRef.current?.values &&
        formikRef.current.values.clients[openAccordianIndex].canceledReason
          ?.cancelReason === '' &&
        formikRef.current.values.clients[openAccordianIndex].status ===
          'Pending'
      ) {
        handlePendingSubmit(formikRef.current?.values);
      } else {
        turnOfMic();
        checkNoteEntered();
        formikRef.current?.submitForm();
      }
    }, 0);
  };

  const proceedWithServiceCodeBypass = (byPassServiceCode: boolean) => {
    handleOnSubmit(
      formikRef.current?.values as ProgressNoteType,
      byPassServiceCode,
    );
  };
  const isStartTimeSame = _.isEqual(
    initialGroupBillingStartTime
      ? moment(initialGroupBillingStartTime, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]')
          .utc(true)
          .local()
          .format('HH:mm')
      : '',
    groupBillingStartTime,
  );

  const isDurationSame = (groupDuration: number) => {
    return initialGroupBillingDuration == groupDuration;
  };

  const markClientFieldsTouched = (clientIndex: number) => {
    const clients = formikRef.current?.values.clients ?? [];

    formikRef.current?.setTouched({
      clients: clients.map((client, idx) =>
        idx === clientIndex
          ? {
              notes: true,
              visits: client.visits.map(() => ({
                startTime: true,
                serviceCode: {
                  id: true,
                  label: true,
                },
                settingCode: {
                  id: true,
                  label: true,
                },
                clientLocationType: true,
                coTreatPartnerName: true,
                telehealthType: true,
                providerLocationType: true,
              })),
            }
          : {},
      ),
    });
  };

  return (
    <>
      {shareModal && shareClientIds && (
        <ShareDownloadModal
          modalVisible={shareModal}
          closeModal={() => {
            setShareModal(false);
            setShareClientIds(null);
          }}
          screenName="progressNote"
          attendeeId={props.clickedAttendeeId}
          commonAppointmentId={props.eventId}
          clientId={shareClientIds.clientId}
          clientReferralId={shareClientIds.referralId}
        />
      )}
      <LanguageSelectionDialog
        open={openDownloadLanguageModal}
        onClose={() => {
          setOpenDownloadLanguageModal(false);
          setDownloadParams(null);
        }}
        onConfirm={(language) => {
          setOpenDownloadLanguageModal(false);
          if (downloadParams) {
            handleDownload(
              downloadParams.clientId,
              downloadParams.attendeeId,
              downloadParams.appointmentId,
              language,
            );
          }
          setDownloadParams(null);
        }}
      />
      {serviceCodes?.showModal && (
        <ServiceCodeValidationModal
          data={serviceCodes}
          onModalClose={() => setServiceCodes(undefined)}
          onProceed={() => proceedWithServiceCodeBypass(true)}
        />
      )}
      <SnackBarComponent
        open={open}
        handleClose={handleCloseSnakBar}
        successOrError={toastrVariable}
        labelId={toastrId}
        defaultMessageId={toastrDefaultMessage}
      />
      <CancelVisits
        openModal={openCancelVisitModal}
        onClose={handleCloseCancelVisit}
        handelLockScreen={handelLockScreen}
      />
      {(initialData?.clients?.length ?? 0) > 0 &&
        initialData?.clients?.[openAccordianIndex]?.client?.firstName &&
        initialData?.clients?.[openAccordianIndex]?.client?.lastName &&
        initialData?.programDetails && (
          <Formik
            initialValues={initialData}
            validationSchema={validationSchema}
            innerRef={formikRef}
            enableReinitialize={true}
            onSubmit={(value) => {
              if (
                value.clients[openAccordianIndex].visits.some(
                  (visit) => !visit.onHold && visit.durationDec === 0,
                )
              ) {
                setIsAnyDurationZero(true);
              } else {
                handleOnSubmit(value, false);
              }
            }}
          >
            {({ values, setFieldValue, errors, touched, validateForm }) => {
              useEffect(() => {
                for (const property of propertiesToCheck) {
                  if (
                    !_.isEqual(
                      _.get(
                        origainalInitialData,
                        `clients[${openAccordianIndex}].${property}`,
                      ),
                      _.get(
                        values,
                        `clients[${openAccordianIndex}].${property}`,
                      ),
                    ) &&
                    validUser
                  ) {
                    handleUpdateUnsavedChanges(true);
                    break;
                  } else {
                    handleUpdateUnsavedChanges(false);
                    // break;
                  }
                }
              }, [values, origainalInitialData, initialData]);
              return (
                <Box sx={{}}>
                  <Card
                    sx={{ padding: '24px' }}
                    onClick={() => {
                      closeDurationModal();
                    }}
                  >
                    {/* Program Details */}
                    <Box sx={{ marginBottom: '16px' }}>
                      <ProgramPanel program={initialData.programDetails} />
                    </Box>

                    {/* Group Billing */}
                    {selectedClient.length > 1 && (
                      <Box
                        sx={{
                          marginBottom: '24px',
                          paddingY: '24px',
                          borderBottom: '1px solid #CFDEDE',
                          borderTop: '1px solid #CFDEDE',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Box>
                            <MediumTypography
                              labelid="groupBillingText"
                              defaultlabel="Clinician Group Billable Hours"
                              sxProps={{
                                fontSize: '18px',
                                fontWeight: 600,
                                color: '#008C82',
                              }}
                            />
                          </Box>
                        </Box>
                        {/*Group Billing Start time and Duration */}
                        <Box>
                          <Box
                            sx={{
                              display: 'flex',
                              marginTop: '24px',
                            }}
                          >
                            <Box
                              sx={{
                                width: '170px',
                                marginRight: '24px',
                              }}
                            >
                              <AppTimePicker
                                name="Start Time"
                                disableManualInput={true}
                                needCrossIcon={false}
                                value={dayjs(groupBillingStartTime, 'HH:mm')}
                                onTimeChange={(time: Dayjs | null) => {
                                  if (time === null) {
                                    setGroupBillingStartTime(null);
                                  } else {
                                    setGroupBillingStartTime(
                                      time.format('HH:mm'),
                                    );
                                  }
                                }}
                                sxButtonProps={{
                                  height: '36px',
                                  borderColor:
                                    !validUser ||
                                    initialData?.clients[openAccordianIndex]
                                      .activitySheetStatus === 'Submitted' ||
                                    initialData?.clients[openAccordianIndex]
                                      .activitySheetStatus === 'Approved'
                                      ? '#CFDEDE'
                                      : undefined,
                                }}
                                disable={checkGroupBillingToDisableForFileds()}
                                minuteStep={1}
                              />
                            </Box>
                            {/* Duration */}
                            <Box key={'groupBillingDurtion'}>
                              <DurationPicker
                                uniqueId={'groupBillingDurtion'}
                                key={'groupBillingDurtion'}
                                interval={25}
                                disabled={checkGroupBillingToDisableForFileds()}
                                required={false}
                                labelId="ProgressNote.duration"
                                defaultLabel="Duration"
                                maxDuration={{
                                  hour: 24,
                                  minutes: 0,
                                }}
                                duration={formatToDurationFromDecimal(
                                  groupBillingDuration || 0.0,
                                )}
                                setDuration={(duration) => {
                                  setGroupBillingDuration(
                                    formatToDecimalFromDuration(duration),
                                  );
                                }}
                              />
                            </Box>
                          </Box>
                          <Box
                            sx={{ display: 'flex', marginTop: '16px' }}
                          ></Box>
                          {checkGroupBillingToDisableForAction() && (
                            <Box>
                              <ButtonComponent
                                className="btn-primary btn-cancel alrt_Width_btn"
                                variantType="contained"
                                labelId="ProgressNote.Cancel"
                                defaultLabelId="Cancel"
                                onClick={() => {
                                  if (
                                    !(
                                      isStartTimeSame &&
                                      isDurationSame(groupBillingDuration)
                                    )
                                  ) {
                                    setGroupBillingCancelModal(true);
                                  }
                                }}
                              />
                              <ButtonComponent
                                variantType="contained"
                                type="submit"
                                className="btn-primary btn-submit alrt_Width_btn ml-md"
                                labelId="ProgressNote.Save"
                                defaultLabelId="Save"
                                onClick={() => {
                                  const updatedBillingStartTime =
                                    groupBillingStartTime
                                      ? moment(
                                          `${localAppointmentDate} ${groupBillingStartTime}`,
                                          'MM/DD/YYYY HH:mm',
                                        )
                                          .utc()
                                          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
                                      : '';
                                  toggleLoader(true);
                                  UpdateGroupBillig(
                                    {
                                      appointmentId:
                                        props.progressNoteData.clients[0]
                                          .appointmentId,
                                      attendeeId: props.clickedAttendeeId,
                                      groupBillingDurationDec:
                                        groupBillingDuration,
                                      groupBillingStartTime:
                                        groupBillingStartTime
                                          ? moment(
                                              `${localAppointmentDate} ${groupBillingStartTime}`,
                                              'MM/DD/YYYY HH:mm',
                                            )
                                              .utc()
                                              .format(
                                                'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
                                              )
                                          : null,
                                      billingModified:
                                        props.progressNoteData.clients[
                                          openAccordianIndex
                                        ].activitySheetStatus === 'Submitted' &&
                                        (!isStartTimeSame ||
                                          !isDurationSame(
                                            groupBillingDuration,
                                          )),

                                      payrollModified:
                                        props.progressNoteData.clients[
                                          openAccordianIndex
                                        ].activitySheetStatus === 'Submitted' &&
                                        !isDurationSame(groupBillingDuration),
                                    },
                                    props.progressNoteData.clients[0]
                                      .commonAppointmentId,
                                  )
                                    .then(() => {
                                      setOpen(true);
                                      setToastrVariable('success');
                                      setToastrId(
                                        'GroupBilling.UpdatedSuccess',
                                      );
                                      setToastrDefaultMessage(
                                        'Group Billing Updated Successfully',
                                      );
                                      setInitialGroupBillingDuration(
                                        groupBillingDuration,
                                      );
                                      setInitialGroupBillingStartTime(
                                        updatedBillingStartTime,
                                      );
                                      toggleLoader(false);
                                    })
                                    .catch(() => {
                                      setOpen(true);
                                      setToastrVariable('error');
                                      setToastrId('GroupBilling.UpdatedError');
                                      setToastrDefaultMessage(
                                        'Failed to Update Group Billing',
                                      );
                                      toggleLoader(false);
                                    });
                                }}
                              />
                            </Box>
                          )}
                        </Box>
                      </Box>
                    )}

                    {/* Client List Bubbel */}

                    {clientCount > 1 && (
                      <Grid
                        container
                        sx={{ marginBottom: '16px' }}
                        rowGap={2}
                        alignItems={'center'}
                      >
                        {selectedClient.map((item, index) => (
                          <>
                            <Grid item key={item.clientId}>
                              <Box
                                component={Button}
                                tabIndex={0}
                                sx={{
                                  '&:hover': {
                                    backgroundColor:
                                      openAccordianIndex === index
                                        ? '#00C6B8'
                                        : '#ffffff', // or whatever your default background color is
                                    color: 'inherit', // or the default text color
                                    // Add any other styles you want to reset on hover
                                  },
                                  display: 'flex',
                                  height: '30px',
                                  width: '120px',
                                  borderRadius: '30px',
                                  textTransform: 'none',
                                  border:
                                    openAccordianIndex !== index
                                      ? '1px solid #97A6A5'
                                      : 'none',
                                  marginRight: '16px',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  backgroundColor:
                                    openAccordianIndex === index
                                      ? '#00C6B8'
                                      : '#ffffff',
                                  cursor: 'pointer',
                                }}
                                onClick={() => {
                                  if (openAccordianIndex !== index) {
                                    formikRef.current?.setTouched({}, false);
                                    setOpenAccordianIndex(index);
                                  }
                                  setOpenAccordian(true);
                                }}
                              >
                                <Tooltip
                                  title={item.clientName}
                                  arrow
                                  followCursor
                                  className="minWidthContent"
                                >
                                  <Box>
                                    <MediumTypography
                                      label={item.clientName}
                                      textColor={
                                        openAccordianIndex === index
                                          ? '#ffffff'
                                          : '#97A6A5'
                                      }
                                      sxProps={{
                                        paddingX: '8px',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        cursor: 'pointer',
                                        textOverflow: 'ellipsis',
                                        maxWidth: '100px',
                                      }}
                                    />
                                  </Box>
                                </Tooltip>
                              </Box>
                            </Grid>
                            {index === selectedClient.length - 1 &&
                              initialData?.clients[openAccordianIndex]
                                .activitySheetStatus !== 'Submitted' &&
                              initialData?.clients[openAccordianIndex]
                                .activitySheetStatus !== 'Approved' &&
                              editClientIndex === null && (
                                <Grid item>
                                  {validUser && (
                                    <MediumTypography
                                      labelid="Progressote.AddDeleteClient"
                                      defaultlabel="Choose Clients"
                                      fontweight={700}
                                      fontSize="14px"
                                      sxProps={{
                                        textDecoration: 'underline',
                                        textUnderlineOffset: '3px',
                                        color: '#00C6B8',
                                        cursor: 'pointer',
                                      }}
                                      onClick={() => {
                                        setIsAddOrDeleteClientAction(false);
                                        setFirstEntry(false);
                                        setOpenClientModal(true);
                                      }}
                                    />
                                  )}
                                </Grid>
                              )}
                          </>
                        ))}
                      </Grid>
                    )}

                    {initialData.clients
                      .filter((initialClient) =>
                        selectedClient.some(
                          (client) =>
                            client.clientId === initialClient.client.clientId,
                        ),
                      )
                      .map((item, sectionIndex) => {
                        const isClientActionDisabled =
                          (item.status === 'Completed' ||
                            item.status === 'Canceled' ||
                            item.activitySheetStatus === 'Submitted' ||
                            item.activitySheetStatus === 'Approved' ||
                            !validUser) &&
                          editClientIndex === null;
                        return (
                          <Box
                            key={item.client.clientId}
                            sx={{
                              backgroundColor: '#ECF9F8',
                              paddingBottom: '24px',
                              marginBottom:
                                sectionIndex === initialData.clients.length - 1
                                  ? '0px'
                                  : '16px',
                              border: '1px solid #00C6B8',
                              borderRadius: '4px',
                            }}
                          >
                            {/* Client details */}
                            <Box
                              sx={{
                                paddingTop: '24px',
                                marginX: '24px',
                                paddingBottom:
                                  openAccordian &&
                                  openAccordianIndex === sectionIndex
                                    ? '24px'
                                    : '0px',
                                borderBottom:
                                  openAccordian &&
                                  openAccordianIndex === sectionIndex
                                    ? '1px solid #00C6B8'
                                    : 'none',
                              }}
                            >
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <Box
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    columnGap: '10px',
                                    cursor: 'default',
                                    marginRight: '4px',
                                  }}
                                >
                                  <MediumTypography
                                    sxProps={{
                                      fontSize: '18px',
                                      fontWeight: 600,
                                      color: '#008C82',
                                    }}
                                    label={
                                      item.client.firstName === ''
                                        ? '-'
                                        : formatName(
                                            item.client.firstName,
                                            item.client.middleName,
                                            item.client.lastName,
                                            item.client.suffix,
                                          )
                                    }
                                  />
                                </Box>

                                <Box
                                  sx={{
                                    flex: 1,
                                    display: 'flex',
                                    justifyContent: 'end',
                                  }}
                                >
                                  {checkProgressNoteAndActivitySheetStatus(
                                    item,
                                  ) && (
                                    <Box
                                      className="cursorPointer mr-sm"
                                      onClick={() => {
                                        setEditClientIndex(sectionIndex);
                                        setEditConfirmOpen(true);
                                      }}
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        border: '1px solid #00C6B8',
                                        borderRadius: '4px',
                                        padding: '2px 6px',
                                        columnGap: '4px',
                                        marginLeft: '8px',
                                        width: 'fit-content',
                                      }}
                                    >
                                      <EditIcon />
                                      <MediumTypography
                                        labelid="editText"
                                        defaultlabel="Edit"
                                        fontSize="14px"
                                      />
                                    </Box>
                                  )}
                                </Box>

                                {clientCount > 1 && (
                                  <Box>
                                    {openAccordian &&
                                    openAccordianIndex === sectionIndex ? (
                                      <Box
                                        sx={{
                                          display: 'flex',
                                          padding: '5px',
                                          cursor: 'pointer',
                                        }}
                                        onClick={() => {
                                          formikRef.current?.setTouched(
                                            {},
                                            false,
                                          );
                                          setOpenAccordian(false);
                                        }}
                                      >
                                        <UpArrow />
                                      </Box>
                                    ) : (
                                      <Box
                                        sx={{
                                          display: 'flex',
                                          padding: '5px',
                                          cursor: 'pointer',
                                        }}
                                        onClick={() => {
                                          formikRef.current?.setTouched(
                                            {},
                                            false,
                                          );
                                          setOpenAccordianIndex(sectionIndex);
                                          setOpenAccordian(true);
                                        }}
                                      >
                                        <DownArrow />
                                      </Box>
                                    )}
                                  </Box>
                                )}
                              </Box>

                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  paddingTop: '8px',
                                  justifyContent: 'space-between',
                                  // columnGap: '24px',
                                }}
                              >
                                <Box sx={{ display: 'flex' }}>
                                  <Box
                                    sx={{
                                      display: 'none',
                                      width: '116px',
                                      marginRight: '24px',
                                    }}
                                  >
                                    <MediumTypography
                                      labelid="ProgressNote.Sex"
                                      defaultlabel="Sex:"
                                      textColor="#97A6A5"
                                      sxProps={{ fontSize: '16px' }}
                                    />
                                    <Box>
                                      <MediumTypography
                                        sxProps={{
                                          fontSize: '16px',
                                          fontWeight: 500,
                                          paddingLeft:
                                            item.client.sex === ''
                                              ? '16px'
                                              : '4px',
                                          color: '#2A4241',
                                        }}
                                        label={
                                          item.client.sex === ''
                                            ? '-'
                                            : convertGenderToFrontend(
                                                item.client.sex,
                                              )
                                        }
                                      />
                                    </Box>
                                  </Box>
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      marginRight: '24px',
                                    }}
                                  >
                                    <MediumTypography
                                      labelid="ProgressNote.DPHID"
                                      defaultlabel="Enrollment ID:"
                                      textColor="#97A6A5"
                                      sxProps={{ fontSize: '16px' }}
                                    />
                                    <Tooltip
                                      title={
                                        item.client.dphId.length > 15
                                          ? item.client.dphId
                                          : null
                                      }
                                      followCursor
                                      arrow={
                                        item.client.dphId.length > 15
                                          ? true
                                          : false
                                      }
                                    >
                                      <Box>
                                        <MediumTypography
                                          textstyle="center"
                                          sxProps={{
                                            fontSize: '16px',
                                            fontWeight: 500,
                                            paddingLeft:
                                              item.client.dphId === ''
                                                ? '50px'
                                                : '4px',
                                            color: '#2A4241',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            cursor: 'pointer',
                                            textOverflow: 'ellipsis',
                                            maxWidth: '150px',
                                          }}
                                          label={
                                            item.client.dphId === ''
                                              ? '-'
                                              : item.client.dphId
                                          }
                                        />
                                      </Box>
                                    </Tooltip>
                                  </Box>
                                  <Box sx={{ display: 'flex' }}>
                                    <MediumTypography
                                      labelid="ProgressNote.DateofBirth"
                                      defaultlabel="Date of Birth:"
                                      textColor="#97A6A5"
                                      sxProps={{ fontSize: '16px' }}
                                    />
                                    <Box>
                                      <MediumTypography
                                        textstyle="center"
                                        sxProps={{
                                          fontSize: '16px',
                                          fontWeight: 500,
                                          marginLeft:
                                            item.client.dob === ''
                                              ? '16px'
                                              : '4px',
                                          marginRight: '24px',
                                          color: '#2A4241',
                                          fontFamily: 'Lato-Regular',
                                        }}
                                        label={
                                          item.client.dob === ''
                                            ? '-'
                                            : item.client.dob
                                        }
                                      />
                                    </Box>
                                  </Box>
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      width: '135px',
                                    }}
                                  >
                                    <MediumTypography
                                      labelid="ProgressNote.Status"
                                      defaultlabel="Status:"
                                      textColor="#97A6A5"
                                      sxProps={{ fontSize: '16px' }}
                                    />
                                    <Box>
                                      <MediumTypography
                                        textstyle="center"
                                        sxProps={{
                                          fontSize: '16px',
                                          fontWeight: 500,
                                          marginLeft: '4px',
                                          textOverflow: 'ellipsis',
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          color: (() => {
                                            const statusColors = {
                                              Completed: '#37D183',
                                              'In Progress': '#F9B803',
                                              Canceled: '#EB4C60',
                                            };
                                            return (
                                              statusColors[
                                                item.status as keyof typeof statusColors
                                              ] ?? '#F9B803'
                                            );
                                          })(),
                                          fontFamily: 'Lato-Regular',
                                        }}
                                        label={(() => {
                                          const statusMap = {
                                            Completed: 'Completed',
                                            'In Progress': 'In Progress',
                                            Canceled: 'Canceled',
                                          };
                                          return (
                                            statusMap[
                                              item.status as keyof typeof statusMap
                                            ] ?? 'Pending'
                                          );
                                        })()}
                                      />
                                    </Box>
                                  </Box>
                                </Box>
                                <Box
                                  sx={{ display: 'flex', alignItems: 'center' }}
                                >
                                  {!offline &&
                                    item.status !== 'Pending' &&
                                    item.visits.some(
                                      (visit) => !visit.onHold,
                                    ) && (
                                      <Box
                                        className="cursorPointer"
                                        onClick={() => {
                                          setDownloadParams({
                                            clientId: item.client.clientId,
                                            attendeeId: props.clickedAttendeeId,
                                            appointmentId: props.eventId,
                                          });
                                          setOpenDownloadLanguageModal(true);
                                        }}
                                      >
                                        <ToolTipIcon
                                          labelId="ConsentForms.listActionDownloadToolTipLabel"
                                          defaultLabel="Download"
                                          Icon={<DownloadIcon />}
                                        />
                                      </Box>
                                    )}
                                  {!offline &&
                                    item.status !== 'Pending' &&
                                    item.visits.some(
                                      (visit) => !visit.onHold,
                                    ) && (
                                      <Box
                                        className="cursorPointer"
                                        onClick={() => {
                                          setShareClientIds({
                                            clientId: item.client.clientId,
                                            referralId: item.client.referralId,
                                          });
                                          setShareModal(true);
                                        }}
                                      >
                                        <ToolTipIcon
                                          labelId="ConsentForms.listActionShareToolTipLabel"
                                          defaultLabel="Share"
                                          Icon={<ShareIcon />}
                                        />
                                      </Box>
                                    )}
                                </Box>
                              </Box>
                            </Box>
                            {openAccordian &&
                              openAccordianIndex === sectionIndex && (
                                <Box sx={{ position: 'relative' }}>
                                  {isScreenLocked &&
                                  formikRef.current?.values.clients[
                                    openAccordianIndex
                                  ].canceledReason?.cancelReason ? (
                                    <Box
                                      className="showCancelPopup"
                                      sx={{
                                        position: 'absolute',
                                        zIndex: 3,
                                        maxWidth: '100%',
                                        width: '100%',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        display: 'flex',
                                        paddingTop: '34px',
                                      }}
                                    >
                                      {showCancelToaster()}
                                    </Box>
                                  ) : null}
                                  <Box
                                    ref={parentRef}
                                    style={{
                                      pointerEvents: isScreenLocked
                                        ? 'none'
                                        : 'auto',
                                    }}
                                    onKeyDownCapture={(e) => {
                                      if (isScreenLocked) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                      }
                                    }}
                                    onFocus={() => {
                                      if (isScreenLocked) {
                                        if (parentRef.current)
                                          parentRef.current.focus();
                                      }
                                    }}
                                  >
                                    <Box sx={{ position: 'relative' }}>
                                      {isScreenLocked &&
                                      formikRef.current?.values.clients[
                                        openAccordianIndex
                                      ].canceledReason?.cancelReason ? (
                                        <Box
                                          sx={{
                                            position: 'absolute',
                                            zIndex: 2,
                                            width: '100%',
                                            height: '100%',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            display: 'flex',
                                            opacity: isScreenLocked
                                              ? '0.3'
                                              : '1 ',
                                            paddingY: '0px',
                                            backgroundColor: '#97A6A5',
                                          }}
                                        ></Box>
                                      ) : null}

                                      {/* Visit Info */}
                                      <Box
                                        sx={{
                                          paddingY: '24px',
                                          marginX: '24px',
                                          borderBottom: '1px solid #00C6B8',
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                          }}
                                        >
                                          <Box>
                                            <MediumTypography
                                              labelid="ProgressNote.VisitInformation"
                                              defaultlabel="Visit Information"
                                              textColor="#213262"
                                              sxProps={{
                                                fontSize: '18px',
                                                fontWeight: 600,
                                                paddingBottom: '16px',
                                              }}
                                            />
                                          </Box>
                                          <Box
                                            sx={{
                                              display: 'flex',
                                              columnGap: '16px',
                                            }}
                                          >
                                            <Box sx={{ display: 'flex' }}>
                                              <MediumTypography
                                                labelid="ProgressNote.Date"
                                                defaultlabel="Date"
                                                textColor="#97A6A5"
                                                sxProps={{ fontSize: '16px' }}
                                              />
                                              <MediumTypography
                                                sxProps={{
                                                  fontSize: '16px',
                                                  fontWeight: 500,
                                                  paddingLeft:
                                                    localAppointmentDate ===
                                                      '' || null
                                                      ? '16px'
                                                      : '4px',
                                                  color: '#2A4241',
                                                  fontFamily: 'Lato-Regular',
                                                }}
                                                labelid={
                                                  localAppointmentDate === ''
                                                    ? '-'
                                                    : localAppointmentDate
                                                }
                                              />
                                            </Box>
                                            <Box sx={{ display: 'flex' }}>
                                              <MediumTypography
                                                labelid="ProgressNote.Individual"
                                                defaultlabel="Individual"
                                                textColor="#97A6A5"
                                                sxProps={{ fontSize: '16px' }}
                                              />
                                              <MediumTypography
                                                label={`${
                                                  formatNumberToDecimal(
                                                    values.clients[
                                                      openAccordianIndex
                                                    ].individualHrsDec,
                                                  ) || '0.00'
                                                }`}
                                                fontSize="16px"
                                                fontweight={500}
                                                textColor="#2A4241"
                                                className="ml-xs"
                                              />
                                            </Box>
                                            <Box sx={{ display: 'flex' }}>
                                              <MediumTypography
                                                labelid="ProgressNote.ActualAppointmentDuration"
                                                defaultlabel="Appointment scheduled:"
                                                textColor="#97A6A5"
                                                sxProps={{ fontSize: '16px' }}
                                              />
                                              <MediumTypography
                                                label={`${
                                                  formatNumberToDecimal(
                                                    values.clients[
                                                      openAccordianIndex
                                                    ].actualAppointmentTimeDec,
                                                  ) || '0.00'
                                                }`}
                                                fontSize="16px"
                                                fontweight={500}
                                                textColor="#2A4241"
                                                className="ml-xs"
                                              />
                                            </Box>
                                            <Box sx={{ display: 'flex' }}>
                                              <MediumTypography
                                                labelid="ProgressNote.Co-Tx"
                                                defaultlabel="Co-Treatment:"
                                                textColor="#97A6A5"
                                                sxProps={{ fontSize: '16px' }}
                                              />
                                              <MediumTypography
                                                label={`${
                                                  formatNumberToDecimal(
                                                    values.clients[
                                                      openAccordianIndex
                                                    ].coTreatmentHrsDec,
                                                  ) || '0.00'
                                                }`}
                                                fontSize="16px"
                                                fontweight={500}
                                                textColor="#2A4241"
                                                className="ml-xs"
                                              />
                                            </Box>
                                            {!offline ? (
                                              <Box
                                                sx={{
                                                  cursor: isClientActionDisabled
                                                    ? 'not-allowed'
                                                    : 'pointer',
                                                  opacity:
                                                    isClientActionDisabled
                                                      ? 0.5
                                                      : 1,
                                                }}
                                              >
                                                <Box
                                                  sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                  }}
                                                  onClick={async () => {
                                                    if (isClientActionDisabled)
                                                      return;

                                                    if (
                                                      values.clients[
                                                        openAccordianIndex
                                                      ].status !== 'Pending'
                                                    ) {
                                                      const newErrors =
                                                        await formikRef.current?.validateForm();

                                                      markClientFieldsTouched(
                                                        openAccordianIndex,
                                                      );

                                                      if (
                                                        newErrors?.clients?.[
                                                          openAccordianIndex
                                                        ]
                                                      ) {
                                                        return;
                                                      }
                                                    }

                                                    setOpenCancelVisitModal(
                                                      true,
                                                    );
                                                  }}
                                                >
                                                  <Stop />
                                                  <MediumTypography
                                                    labelid="ProgressNote.CancelVisit"
                                                    defaultlabel="Cancel Progress Note"
                                                    textColor="#EB4C60"
                                                    sxProps={{
                                                      fontSize: '16px',
                                                      paddingLeft: '4px',
                                                    }}
                                                  />
                                                </Box>
                                              </Box>
                                            ) : null}
                                          </Box>
                                        </Box>

                                        {/* Telehealth */}
                                        <Box
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              display: 'flex',
                                              alignItems: 'center',
                                            }}
                                          >
                                            <CheckBoxComponent
                                              ischecked={
                                                values.clients[sectionIndex].tpc
                                              }
                                              CheckHandleChange={(e) => {
                                                setFieldValue(
                                                  `clients[${openAccordianIndex}].tpc`,
                                                  e.target.checked,
                                                );
                                              }}
                                              disabled={
                                                isClientActionDisabled ||
                                                (isScreenLocked &&
                                                  !!formikRef.current?.values
                                                    .clients[openAccordianIndex]
                                                    .canceledReason
                                                    ?.cancelReason)
                                              }
                                              labelid="ProgressNote.TPC"
                                              defaultlabelid="TPC"
                                            />
                                          </Box>
                                        </Box>

                                        {initialData.clients[
                                          openAccordianIndex
                                        ].visits.map((visit, index) => (
                                          <Box
                                            sx={{
                                              display: 'flex',
                                              pointerEvents:
                                                visit.activitySheetStatus ===
                                                'Approved'
                                                  ? 'none'
                                                  : 'auto',
                                            }}
                                            key={`${index}+visits`}
                                          >
                                            <Box
                                              sx={{
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #CFDEDE',
                                                borderRadius: '4px',
                                                padding: '24px 24px 16px 24px',
                                                marginBottom:
                                                  index !==
                                                  initialData.clients[
                                                    openAccordianIndex
                                                  ].visits.length -
                                                    1
                                                    ? '16px'
                                                    : '0px',
                                              }}
                                            >
                                              <Box
                                                sx={{
                                                  display: 'flex',
                                                  alignItems: 'flex-start',
                                                }}
                                              >
                                                {/* CoTx */}

                                                <Box
                                                  sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    paddingBottom:
                                                      errors?.clients?.[
                                                        openAccordianIndex
                                                      ] &&
                                                      (
                                                        errors.clients[
                                                          openAccordianIndex
                                                        ] as FormikErrors<ProgressNoteClient>
                                                      ).visits &&
                                                      (
                                                        (
                                                          errors.clients[
                                                            openAccordianIndex
                                                          ] as FormikErrors<ProgressNoteClient>
                                                        )
                                                          .visits as FormikErrors<
                                                          ProgressNoteVisit[]
                                                        >
                                                      )[index]
                                                        ?.telehealthType &&
                                                      touched.clients?.[
                                                        openAccordianIndex
                                                      ]?.visits?.[index]
                                                        ?.telehealthType
                                                        ? '32px'
                                                        : '16px',
                                                  }}
                                                >
                                                  <Box
                                                    sx={{
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                    }}
                                                  >
                                                    <CheckBoxComponent
                                                      ischecked={
                                                        values.clients[
                                                          sectionIndex
                                                        ].visits[index]
                                                          ?.telehealth
                                                      }
                                                      CheckHandleChange={(
                                                        value,
                                                      ) => {
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.telehealth`,
                                                          value.target.checked,
                                                        );
                                                        if (
                                                          !value.target.checked
                                                        ) {
                                                          setFieldValue(
                                                            `clients.${openAccordianIndex}.visits.${index}.telehealthType`,
                                                            null,
                                                          );
                                                          setFieldValue(
                                                            `clients.${openAccordianIndex}.visits.${index}.providerLocationType`,
                                                            null,
                                                          );
                                                        }
                                                      }}
                                                      disabled={
                                                        item.status ===
                                                          'Completed' ||
                                                        item.status ===
                                                          'Canceled' ||
                                                        !validUser ||
                                                        visit.activitySheetStatus ===
                                                          'Approved' ||
                                                        (isScreenLocked &&
                                                          !!formikRef.current
                                                            ?.values.clients[
                                                            openAccordianIndex
                                                          ].canceledReason
                                                            ?.cancelReason)
                                                      }
                                                      labelid="ProgressNote.Telehealth"
                                                      defaultlabelid="Telehealth"
                                                    />
                                                  </Box>
                                                  {values.clients[sectionIndex]
                                                    .visits[index]
                                                    .telehealth && (
                                                    <Box
                                                      sx={{ display: 'flex' }}
                                                    >
                                                      <CustomRadioButton
                                                        needUnSelect={false}
                                                        data={
                                                          TeleHealthRadioData
                                                        }
                                                        onSelectItem={(
                                                          value,
                                                        ) => {
                                                          const visits =
                                                            values.clients[
                                                              sectionIndex
                                                            ].visits[index];

                                                          const isAudioTelehealthTypematchTheSettingCode =
                                                            visits?.settingCode
                                                              ?.id === '93' &&
                                                            value === 'audio';
                                                          const isVideoTelehealthTypematchTheSettingCode =
                                                            visits?.settingCode
                                                              ?.id === '95' &&
                                                            value === 'video';
                                                          setFieldValue(
                                                            `clients.${openAccordianIndex}.visits.${index}.telehealthType`,
                                                            value,
                                                          );
                                                          if (
                                                            !isAudioTelehealthTypematchTheSettingCode ||
                                                            !isVideoTelehealthTypematchTheSettingCode
                                                          ) {
                                                            setFieldValue(
                                                              `clients.${openAccordianIndex}.visits.${index}.settingCode`,
                                                              {
                                                                id: '',
                                                                label: '',
                                                              },
                                                            );
                                                          }
                                                          // Validate once after both field updates.
                                                          setTimeout(() => {
                                                            validateForm();
                                                          }, 0);
                                                        }}
                                                        value={
                                                          values.clients[
                                                            openAccordianIndex
                                                          ].visits[index]
                                                            ?.telehealthType
                                                        }
                                                        disable={
                                                          item.status ===
                                                            'Completed' ||
                                                          item.status ===
                                                            'Canceled' ||
                                                          !validUser ||
                                                          visit.activitySheetStatus ===
                                                            'Approved' ||
                                                          (isScreenLocked &&
                                                            !!formikRef.current
                                                              ?.values.clients[
                                                              openAccordianIndex
                                                            ].canceledReason
                                                              ?.cancelReason)
                                                        }
                                                      />
                                                      {errors?.clients?.[
                                                        openAccordianIndex
                                                      ] &&
                                                        (
                                                          errors.clients[
                                                            openAccordianIndex
                                                          ] as FormikErrors<ProgressNoteClient>
                                                        ).visits &&
                                                        (
                                                          (
                                                            errors.clients[
                                                              openAccordianIndex
                                                            ] as FormikErrors<ProgressNoteClient>
                                                          )
                                                            .visits as FormikErrors<
                                                            ProgressNoteVisit[]
                                                          >
                                                        )[index]
                                                          ?.telehealthType &&
                                                        touched.clients?.[
                                                          openAccordianIndex
                                                        ]?.visits?.[index]
                                                          ?.telehealthType && (
                                                          <MediumTypography
                                                            labelid={
                                                              (
                                                                errors.clients[
                                                                  openAccordianIndex
                                                                ] as FormikErrors<ProgressNoteClient>
                                                              ).visits &&
                                                              (
                                                                (
                                                                  errors
                                                                    .clients[
                                                                    openAccordianIndex
                                                                  ] as FormikErrors<ProgressNoteClient>
                                                                )
                                                                  .visits as FormikErrors<
                                                                  ProgressNoteVisit[]
                                                                >
                                                              )[index]
                                                                ?.telehealthType
                                                            }
                                                            defaultlabel="Audio or Video is Required"
                                                            sxProps={{
                                                              marginTop: '24px',
                                                              color:
                                                                'var( --thom-radical-red)',
                                                              position:
                                                                'absolute',
                                                            }}
                                                          />
                                                        )}
                                                    </Box>
                                                  )}
                                                </Box>

                                                <Box
                                                  sx={{
                                                    flex: 1,
                                                    display: 'flex',
                                                    justifyContent: 'end',
                                                  }}
                                                >
                                                  <Box className="flex__">
                                                    <MediumTypography
                                                      className="mr-sm"
                                                      labelid={
                                                        'ProgressNote.Status'
                                                      }
                                                      defaultlabel="Status:"
                                                    />
                                                    <MediumTypography
                                                      label={getActivitySheetVisitStatus(
                                                        values.clients[
                                                          openAccordianIndex
                                                        ].visits[index],
                                                      )}
                                                      textColor={`${getStatusColor(
                                                        getActivitySheetVisitStatus(
                                                          values.clients[
                                                            openAccordianIndex
                                                          ].visits[index],
                                                        ),
                                                      )}`}
                                                    />
                                                  </Box>
                                                </Box>
                                              </Box>

                                              <Box
                                                sx={{
                                                  display: 'flex',
                                                }}
                                              >
                                                {values?.clients?.[sectionIndex]
                                                  .visits?.[index]
                                                  .telehealth && (
                                                  <Box
                                                    sx={{
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      paddingBottom:
                                                        errors?.clients?.[
                                                          openAccordianIndex
                                                        ] &&
                                                        (
                                                          errors.clients[
                                                            openAccordianIndex
                                                          ] as FormikErrors<ProgressNoteClient>
                                                        ).visits &&
                                                        (
                                                          (
                                                            errors.clients[
                                                              openAccordianIndex
                                                            ] as FormikErrors<ProgressNoteClient>
                                                          )
                                                            .visits as FormikErrors<
                                                            ProgressNoteVisit[]
                                                          >
                                                        )[index]
                                                          ?.providerLocationType &&
                                                        touched.clients?.[
                                                          openAccordianIndex
                                                        ]?.visits?.[index]
                                                          ?.providerLocationType
                                                          ? '32px'
                                                          : '16px',
                                                    }}
                                                  >
                                                    <MediumTypography
                                                      labelid="ProgressNote.ProviderLocation"
                                                      defaultlabel="Provider’s Location:"
                                                      sxProps={{
                                                        paddingRight: '16px',
                                                        fontSize: '16px',
                                                      }}
                                                      textColor="#97A6A5"
                                                    />
                                                    <Box
                                                      sx={{ display: 'flex' }}
                                                    >
                                                      <CustomRadioButton
                                                        needUnSelect={false}
                                                        data={clientLocation.map(
                                                          (i) =>
                                                            ({
                                                              label: i.label,
                                                              value: i.id,
                                                            } as RadioButtonData),
                                                        )}
                                                        onSelectItem={(
                                                          value,
                                                        ) => {
                                                          setFieldValue(
                                                            `clients.${openAccordianIndex}.visits.${index}.providerLocationType`,
                                                            value,
                                                          );
                                                        }}
                                                        value={
                                                          values.clients[
                                                            openAccordianIndex
                                                          ].visits[index]
                                                            ?.providerLocationType
                                                        }
                                                        disable={
                                                          item.status ===
                                                            'Completed' ||
                                                          item.status ===
                                                            'Canceled' ||
                                                          !validUser ||
                                                          visit.activitySheetStatus ===
                                                            'Approved' ||
                                                          (isScreenLocked &&
                                                            !!formikRef.current
                                                              ?.values.clients[
                                                              openAccordianIndex
                                                            ].canceledReason
                                                              ?.cancelReason)
                                                        }
                                                      />
                                                      {errors?.clients?.[
                                                        openAccordianIndex
                                                      ] &&
                                                        (
                                                          errors.clients[
                                                            openAccordianIndex
                                                          ] as FormikErrors<ProgressNoteClient>
                                                        ).visits &&
                                                        (
                                                          (
                                                            errors.clients[
                                                              openAccordianIndex
                                                            ] as FormikErrors<ProgressNoteClient>
                                                          )
                                                            .visits as FormikErrors<
                                                            ProgressNoteVisit[]
                                                          >
                                                        )[index]
                                                          ?.providerLocationType &&
                                                        touched.clients?.[
                                                          openAccordianIndex
                                                        ]?.visits?.[index] &&
                                                        touched.clients?.[
                                                          openAccordianIndex
                                                        ]?.visits?.[index]
                                                          ?.providerLocationType && (
                                                          <MediumTypography
                                                            label="Provider Location is Required"
                                                            sxProps={{
                                                              marginTop: '24px',
                                                              color:
                                                                'var(--thom-radical-red)',
                                                              position:
                                                                'absolute',
                                                            }}
                                                          />
                                                        )}
                                                    </Box>
                                                  </Box>
                                                )}
                                              </Box>
                                              {/* Start time and Duration */}
                                              <Box
                                                sx={{
                                                  display: 'flex',
                                                  paddingBottom:
                                                    errors?.clients?.[
                                                      openAccordianIndex
                                                    ] &&
                                                    (
                                                      errors.clients[
                                                        openAccordianIndex
                                                      ] as FormikErrors<ProgressNoteClient>
                                                    ).visits &&
                                                    (
                                                      (
                                                        errors.clients[
                                                          openAccordianIndex
                                                        ] as FormikErrors<ProgressNoteClient>
                                                      ).visits as FormikErrors<
                                                        ProgressNoteVisit[]
                                                      >
                                                    )[index]?.startTime &&
                                                    touched.clients?.[
                                                      openAccordianIndex
                                                    ]?.visits?.[index]
                                                      ?.startTime
                                                      ? '24px'
                                                      : '16px',
                                                }}
                                              >
                                                <Box
                                                  sx={{
                                                    width: '170px',
                                                    marginRight: '24px',
                                                  }}
                                                >
                                                  <AppTimePicker
                                                    name="Start Time"
                                                    disableManualInput={true}
                                                    needCrossIcon={false}
                                                    value={
                                                      values.clients[
                                                        sectionIndex
                                                      ].visits[index] &&
                                                      values.clients[
                                                        sectionIndex
                                                      ].visits[index]
                                                        .startTime !== ''
                                                        ? dayjs(
                                                            values.clients[
                                                              sectionIndex
                                                            ].visits[index]
                                                              .startTime,
                                                            'HH:mm',
                                                          )
                                                        : null
                                                    }
                                                    onTimeChange={(
                                                      time: Dayjs | null,
                                                    ) => {
                                                      if (time === null) {
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.startTime`,
                                                          '',
                                                        );
                                                      } else {
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.startTime`,
                                                          time.format('HH:mm'),
                                                        );
                                                      }
                                                    }}
                                                    sxButtonProps={{
                                                      height: '36px',
                                                      borderColor:
                                                        item.status ===
                                                          'Completed' ||
                                                        !validUser
                                                          ? '#CFDEDE'
                                                          : undefined,
                                                    }}
                                                    disable={
                                                      item.status ===
                                                        'Completed' ||
                                                      item.status ===
                                                        'Canceled' ||
                                                      !validUser ||
                                                      visit.activitySheetStatus ===
                                                        'Approved' ||
                                                      (isScreenLocked &&
                                                        !!formikRef.current
                                                          ?.values.clients[
                                                          openAccordianIndex
                                                        ].canceledReason
                                                          ?.cancelReason)
                                                    }
                                                    minuteStep={1}
                                                  />
                                                  {errors.clients?.[
                                                    openAccordianIndex
                                                  ] &&
                                                    (
                                                      errors.clients[
                                                        openAccordianIndex
                                                      ] as FormikErrors<ProgressNoteClient>
                                                    ).visits &&
                                                    (
                                                      (
                                                        errors.clients[
                                                          openAccordianIndex
                                                        ] as FormikErrors<ProgressNoteClient>
                                                      ).visits as FormikErrors<
                                                        ProgressNoteVisit[]
                                                      >
                                                    )[index]?.startTime &&
                                                    touched.clients?.[
                                                      openAccordianIndex
                                                    ]?.visits?.[index] &&
                                                    touched.clients?.[
                                                      openAccordianIndex
                                                    ]?.visits?.[index]
                                                      ?.startTime && (
                                                      <MediumTypography
                                                        labelid={
                                                          (
                                                            errors.clients[
                                                              openAccordianIndex
                                                            ] as FormikErrors<ProgressNoteClient>
                                                          ).visits &&
                                                          (
                                                            (
                                                              errors.clients[
                                                                openAccordianIndex
                                                              ] as FormikErrors<ProgressNoteClient>
                                                            )
                                                              .visits as FormikErrors<
                                                              ProgressNoteVisit[]
                                                            >
                                                          )[index]?.startTime
                                                        }
                                                        defaultlabel="Start Time is Required"
                                                        sxProps={{
                                                          color:
                                                            'var( --thom-radical-red)',
                                                          position: 'absolute',
                                                        }}
                                                      />
                                                    )}
                                                </Box>
                                                {/* Duration */}
                                                <Box>
                                                  <DurationPicker
                                                    uniqueId={`duration${index}`}
                                                    interval={25}
                                                    disabled={
                                                      item.status ===
                                                        'Completed' ||
                                                      item.status ===
                                                        'Canceled' ||
                                                      !validUser ||
                                                      visit.activitySheetStatus ===
                                                        'Approved' ||
                                                      (isScreenLocked &&
                                                        !!formikRef.current
                                                          ?.values.clients[
                                                          openAccordianIndex
                                                        ].canceledReason
                                                          ?.cancelReason)
                                                    }
                                                    required={false}
                                                    labelId="ProgressNote.duration"
                                                    defaultLabel="Duration"
                                                    maxDuration={{
                                                      hour: 24,
                                                      minutes: 0,
                                                    }}
                                                    duration={formatToDurationFromDecimal(
                                                      values.clients[
                                                        openAccordianIndex
                                                      ].visits[index]
                                                        ?.durationDec ?? 0,
                                                    )}
                                                    setDuration={(duration) => {
                                                      setStartDuration(
                                                        duration.hour,
                                                      );
                                                      setEndDuration(
                                                        duration.minutes,
                                                      );
                                                      setFieldValue(
                                                        `clients.${openAccordianIndex}.visits.${index}.durationDec`,
                                                        formatToDecimalFromDuration(
                                                          duration,
                                                        ),
                                                      );
                                                    }}
                                                  />
                                                  {errors.clients?.[
                                                    openAccordianIndex
                                                  ] &&
                                                    (
                                                      errors.clients[
                                                        openAccordianIndex
                                                      ] as FormikErrors<ProgressNoteClient>
                                                    ).visits &&
                                                    (
                                                      (
                                                        errors.clients[
                                                          openAccordianIndex
                                                        ] as FormikErrors<ProgressNoteClient>
                                                      ).visits as FormikErrors<
                                                        ProgressNoteVisit[]
                                                      >
                                                    )[index]?.durationDec &&
                                                    touched.clients?.[
                                                      openAccordianIndex
                                                    ]?.visits?.[index]
                                                      ?.durationDec && (
                                                      <MediumTypography
                                                        labelid={
                                                          (
                                                            errors.clients[
                                                              openAccordianIndex
                                                            ] as FormikErrors<ProgressNoteClient>
                                                          ).visits &&
                                                          (
                                                            (
                                                              errors.clients[
                                                                openAccordianIndex
                                                              ] as FormikErrors<ProgressNoteClient>
                                                            )
                                                              .visits as FormikErrors<
                                                              ProgressNoteVisit[]
                                                            >
                                                          )[index]?.durationDec
                                                        }
                                                        defaultlabel="Duration is Required"
                                                        sxProps={{
                                                          color:
                                                            'var( --thom-radical-red)',
                                                          marginTop: '8px',
                                                        }}
                                                      />
                                                    )}
                                                </Box>
                                              </Box>
                                              {/* Codes */}
                                              <Grid
                                                container
                                                xs={12}
                                                sx={{
                                                  marginBottom:
                                                    (errors.clients?.[
                                                      openAccordianIndex
                                                    ] &&
                                                      (
                                                        errors.clients[
                                                          openAccordianIndex
                                                        ] as FormikErrors<ProgressNoteClient>
                                                      ).visits &&
                                                      (
                                                        (
                                                          errors.clients[
                                                            openAccordianIndex
                                                          ] as FormikErrors<ProgressNoteClient>
                                                        )
                                                          .visits as FormikErrors<
                                                          ProgressNoteVisit[]
                                                        >
                                                      )[index]?.serviceCode
                                                        ?.id &&
                                                      touched.clients?.[
                                                        openAccordianIndex
                                                      ]?.visits?.[index]
                                                        ?.serviceCode?.id) ||
                                                    (errors.clients?.[
                                                      openAccordianIndex
                                                    ] &&
                                                      (
                                                        errors.clients[
                                                          openAccordianIndex
                                                        ] as FormikErrors<ProgressNoteClient>
                                                      ).visits &&
                                                      (
                                                        (
                                                          errors.clients[
                                                            openAccordianIndex
                                                          ] as FormikErrors<ProgressNoteClient>
                                                        )
                                                          .visits as FormikErrors<
                                                          ProgressNoteVisit[]
                                                        >
                                                      )[index]?.settingCode
                                                        ?.id &&
                                                      touched.clients?.[
                                                        openAccordianIndex
                                                      ]?.visits?.[index]
                                                        ?.settingCode?.id)
                                                      ? '32px'
                                                      : '16px',
                                                }}
                                              >
                                                <Grid
                                                  item
                                                  xs={6}
                                                  sx={{ paddingRight: '20px' }}
                                                >
                                                  <AutocompleteSearch
                                                    labelId={
                                                      'ProgressNote.ServiceCode'
                                                    }
                                                    defaultId={'Service Code'}
                                                    selectedValue={{
                                                      id: values.clients?.[
                                                        openAccordianIndex
                                                      ]?.visits?.[index]
                                                        ? values.clients[
                                                            openAccordianIndex
                                                          ].visits[index]
                                                            .serviceCode?.id
                                                        : props.progressNoteData
                                                            .clients[
                                                            openAccordianIndex
                                                          ].visits[index]
                                                            ?.serviceCode?.id,
                                                      label: values.clients?.[
                                                        openAccordianIndex
                                                      ]?.visits?.[index]
                                                        ? values.clients[
                                                            openAccordianIndex
                                                          ].visits[index]
                                                            .serviceCode?.label
                                                        : props.progressNoteData
                                                            .clients[
                                                            openAccordianIndex
                                                          ].visits[index]
                                                            ?.serviceCode
                                                            ?.label,
                                                    }}
                                                    data={
                                                      values.clients[
                                                        openAccordianIndex
                                                      ].status === 'Completed'
                                                        ? [
                                                            item.visits[index]
                                                              .serviceCode,
                                                          ]
                                                        : serviceCode
                                                            .filter((code) => {
                                                              return (
                                                                code.active ||
                                                                code.code ===
                                                                  item.visits[
                                                                    index
                                                                  ].serviceCode
                                                                    .id
                                                              );
                                                            })
                                                            .map((code) => ({
                                                              id: code.code,
                                                              label: `${code.code} - ${code.description}`,
                                                            }))
                                                    }
                                                    onSelectItem={(
                                                      value: OptionType | null,
                                                    ) => {
                                                      setFieldValue(
                                                        `clients.${openAccordianIndex}.visits.${index}.coTreatPartnerName`,
                                                        [],
                                                      );
                                                      if (value) {
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.serviceCode`,
                                                          {
                                                            id: value.id,
                                                            label: value.label,
                                                          },
                                                        );
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.settingCode`,
                                                          {
                                                            id: '',
                                                            label: '',
                                                          },
                                                        );
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.coTx`,
                                                          false,
                                                        );
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.ifspMeeting`,
                                                          false,
                                                        );
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.asessmentHomeVisit`,
                                                          false,
                                                        );
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.supervisionCoTxHV`,
                                                          false,
                                                        );
                                                        setTimeout(() => {
                                                          handelCoTreatmentDuration(
                                                            index,
                                                            false,
                                                          );
                                                        }, 100);
                                                      } else {
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.serviceCode`,
                                                          {
                                                            id: '',
                                                            label: '',
                                                          },
                                                        );
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.settingCode`,
                                                          {
                                                            id: '',
                                                            label: '',
                                                          },
                                                        );
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.coTx`,
                                                          false,
                                                        );
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.ifspMeeting`,
                                                          false,
                                                        );
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.asessmentHomeVisit`,
                                                          false,
                                                        );
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.supervisionCoTxHV`,
                                                          false,
                                                        );
                                                        setTimeout(() => {
                                                          handelCoTreatmentDuration(
                                                            index,
                                                            false,
                                                          );
                                                        }, 100);
                                                      }
                                                    }}
                                                    disableLabel={false}
                                                    disabled={
                                                      item.status ===
                                                        'Completed' ||
                                                      item.status ===
                                                        'Canceled' ||
                                                      !validUser ||
                                                      visit.activitySheetStatus ===
                                                        'Approved' ||
                                                      (isScreenLocked &&
                                                        !!formikRef.current
                                                          ?.values.clients[
                                                          openAccordianIndex
                                                        ].canceledReason
                                                          ?.cancelReason)
                                                    }
                                                  />
                                                  {errors.clients?.[
                                                    openAccordianIndex
                                                  ] &&
                                                    (
                                                      errors.clients[
                                                        openAccordianIndex
                                                      ] as FormikErrors<ProgressNoteClient>
                                                    ).visits &&
                                                    (
                                                      (
                                                        errors.clients[
                                                          openAccordianIndex
                                                        ] as FormikErrors<ProgressNoteClient>
                                                      ).visits as FormikErrors<
                                                        ProgressNoteVisit[]
                                                      >
                                                    )[index]?.serviceCode?.id &&
                                                    touched.clients?.[
                                                      openAccordianIndex
                                                    ]?.visits?.[index]
                                                      ?.serviceCode?.id && (
                                                      <MediumTypography
                                                        labelid={
                                                          (
                                                            errors.clients[
                                                              openAccordianIndex
                                                            ] as FormikErrors<ProgressNoteClient>
                                                          ).visits &&
                                                          (
                                                            (
                                                              errors.clients[
                                                                openAccordianIndex
                                                              ] as FormikErrors<ProgressNoteClient>
                                                            )
                                                              .visits as FormikErrors<
                                                              ProgressNoteVisit[]
                                                            >
                                                          )[index]?.serviceCode
                                                            ?.id
                                                        }
                                                        defaultlabel="Service code is Required"
                                                        sxProps={{
                                                          color:
                                                            'var( --thom-radical-red)',
                                                          position: 'absolute',
                                                          marginTop: '8px',
                                                        }}
                                                      />
                                                    )}
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={6}
                                                  sx={{ paddingLeft: '20px' }}
                                                >
                                                  <AutocompleteSearch
                                                    labelId={
                                                      'ProgressNote.SettingsCode'
                                                    }
                                                    defaultId={'Settings Code'}
                                                    onSelectItem={(
                                                      value: OptionType | null,
                                                    ) => {
                                                      setSettingChange(
                                                        !settingChange,
                                                      );
                                                      if (value) {
                                                        const defaultLocation =
                                                          settingCode.find(
                                                            (defaultLoc) =>
                                                              defaultLoc.code ===
                                                              value.id,
                                                          )?.defaultLocation;
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.settingCode`,
                                                          {
                                                            id: value.id,
                                                            label: value.label,
                                                          },
                                                        );
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.clientLocationType`,
                                                          defaultLocation,
                                                        );
                                                        setCurrentVisitIndex(
                                                          index,
                                                        );
                                                      } else {
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.settingCode`,
                                                          {
                                                            id: '',
                                                            label: '',
                                                          },
                                                        );
                                                        setCurrentVisitIndex(
                                                          index,
                                                        );
                                                      }
                                                    }}
                                                    data={
                                                      values.clients[
                                                        openAccordianIndex
                                                      ].status === 'Completed'
                                                        ? [
                                                            item.visits[index]
                                                              .settingCode,
                                                          ]
                                                        : values.clients[
                                                            openAccordianIndex
                                                          ].visits[index]
                                                            .serviceCode.id ===
                                                          ''
                                                        ? []
                                                        : settingCode
                                                            .filter((code) => {
                                                              const dhpServiceCode =
                                                                serviceCode.find(
                                                                  (cod) =>
                                                                    cod.code ===
                                                                    values
                                                                      .clients[
                                                                      openAccordianIndex
                                                                    ].visits[
                                                                      index
                                                                    ]
                                                                      .serviceCode
                                                                      ?.id,
                                                                )?.dphServiceCode;

                                                              return code?.dphServiceCode?.includes(
                                                                dhpServiceCode ||
                                                                  '',
                                                              );
                                                            })
                                                            .filter((code) => {
                                                              const visits =
                                                                values.clients[
                                                                  sectionIndex
                                                                ].visits[index];

                                                              const telehealthType =
                                                                visits?.telehealthType;

                                                              if (
                                                                telehealthType ===
                                                                'video'
                                                              ) {
                                                                return (
                                                                  code.code ===
                                                                  '95'
                                                                );
                                                              }

                                                              if (
                                                                telehealthType ===
                                                                'audio'
                                                              ) {
                                                                return (
                                                                  code.code ===
                                                                  '93'
                                                                );
                                                              }

                                                              return true;
                                                            })
                                                            .map((code) => ({
                                                              id: code.code,
                                                              label: `${code.code} - ${code.description}`,
                                                            }))
                                                    }
                                                    selectedValue={{
                                                      id: values.clients?.[
                                                        openAccordianIndex
                                                      ]?.visits?.[index]
                                                        ? values.clients[
                                                            openAccordianIndex
                                                          ].visits[index]
                                                            .settingCode?.id
                                                        : props.progressNoteData
                                                            .clients[
                                                            openAccordianIndex
                                                          ].visits[index]
                                                            ?.settingCode?.id,
                                                      label: values.clients?.[
                                                        openAccordianIndex
                                                      ]?.visits?.[index]
                                                        ? values.clients[
                                                            openAccordianIndex
                                                          ].visits[index]
                                                            .settingCode?.label
                                                        : props.progressNoteData
                                                            .clients[
                                                            openAccordianIndex
                                                          ].visits[index]
                                                            ?.settingCode
                                                            ?.label,
                                                    }}
                                                    disableLabel={false}
                                                    disabled={
                                                      item.status ===
                                                        'Completed' ||
                                                      item.status ===
                                                        'Canceled' ||
                                                      !validUser ||
                                                      visit.activitySheetStatus ===
                                                        'Approved' ||
                                                      (isScreenLocked &&
                                                        !!formikRef.current
                                                          ?.values.clients[
                                                          openAccordianIndex
                                                        ].canceledReason
                                                          ?.cancelReason)
                                                    }
                                                  />
                                                  {errors.clients?.[
                                                    openAccordianIndex
                                                  ] &&
                                                    (
                                                      errors.clients[
                                                        openAccordianIndex
                                                      ] as FormikErrors<ProgressNoteClient>
                                                    ).visits &&
                                                    (
                                                      (
                                                        errors.clients[
                                                          openAccordianIndex
                                                        ] as FormikErrors<ProgressNoteClient>
                                                      ).visits as FormikErrors<
                                                        ProgressNoteVisit[]
                                                      >
                                                    )[index]?.settingCode?.id &&
                                                    touched.clients?.[
                                                      openAccordianIndex
                                                    ]?.visits?.[index] &&
                                                    touched.clients?.[
                                                      openAccordianIndex
                                                    ]?.visits?.[index]
                                                      ?.settingCode?.id && (
                                                      <MediumTypography
                                                        labelid={
                                                          (
                                                            errors.clients[
                                                              openAccordianIndex
                                                            ] as FormikErrors<ProgressNoteClient>
                                                          ).visits &&
                                                          (
                                                            (
                                                              errors.clients[
                                                                openAccordianIndex
                                                              ] as FormikErrors<ProgressNoteClient>
                                                            )
                                                              .visits as FormikErrors<
                                                              ProgressNoteVisit[]
                                                            >
                                                          )[index]?.settingCode
                                                            ?.id
                                                        }
                                                        defaultlabel="Settings code is Required"
                                                        sxProps={{
                                                          color:
                                                            'var( --thom-radical-red)',
                                                          position: 'absolute',
                                                          marginTop: '8px',
                                                        }}
                                                      />
                                                    )}
                                                </Grid>
                                              </Grid>

                                              {/* Client Location */}
                                              <Box
                                                sx={{
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  paddingBottom:
                                                    errors?.clients?.[
                                                      openAccordianIndex
                                                    ] &&
                                                    (
                                                      errors.clients[
                                                        openAccordianIndex
                                                      ] as FormikErrors<ProgressNoteClient>
                                                    ).visits &&
                                                    (
                                                      (
                                                        errors.clients[
                                                          openAccordianIndex
                                                        ] as FormikErrors<ProgressNoteClient>
                                                      ).visits as FormikErrors<
                                                        ProgressNoteVisit[]
                                                      >
                                                    )[index]
                                                      ?.clientLocationType &&
                                                    touched.clients?.[
                                                      openAccordianIndex
                                                    ]?.visits?.[index]
                                                      ?.clientLocationType
                                                      ? '16px'
                                                      : 'unset',
                                                }}
                                              >
                                                <MediumTypography
                                                  labelid="ProgressNote.ClientLocation"
                                                  defaultlabel="Client’s Location:"
                                                  sxProps={{
                                                    paddingRight: '16px',
                                                    fontSize: '16px',
                                                  }}
                                                  textColor="#97A6A5"
                                                />
                                                <Box sx={{ display: 'flex' }}>
                                                  <CustomRadioButton
                                                    needUnSelect={false}
                                                    data={clientLocation.map(
                                                      (i) =>
                                                        ({
                                                          label: i.label,
                                                          value: i.id,
                                                        } as RadioButtonData),
                                                    )}
                                                    onSelectItem={(value) => {
                                                      setFieldValue(
                                                        `clients.${openAccordianIndex}.visits.${index}.clientLocationType`,
                                                        value,
                                                      );
                                                    }}
                                                    value={
                                                      values.clients[
                                                        openAccordianIndex
                                                      ].visits[index]
                                                        ?.clientLocationType
                                                    }
                                                    disable={
                                                      item.status ===
                                                        'Completed' ||
                                                      item.status ===
                                                        'Canceled' ||
                                                      !validUser ||
                                                      visit.activitySheetStatus ===
                                                        'Approved' ||
                                                      (isScreenLocked &&
                                                        !!formikRef.current
                                                          ?.values.clients[
                                                          openAccordianIndex
                                                        ].canceledReason
                                                          ?.cancelReason)
                                                    }
                                                  />
                                                  {errors.clients?.[
                                                    openAccordianIndex
                                                  ] &&
                                                    (
                                                      errors.clients[
                                                        openAccordianIndex
                                                      ] as FormikErrors<ProgressNoteClient>
                                                    ).visits &&
                                                    (
                                                      (
                                                        errors.clients[
                                                          openAccordianIndex
                                                        ] as FormikErrors<ProgressNoteClient>
                                                      ).visits as FormikErrors<
                                                        ProgressNoteVisit[]
                                                      >
                                                    )[index]
                                                      ?.clientLocationType &&
                                                    touched.clients?.[
                                                      openAccordianIndex
                                                    ]?.visits?.[index]
                                                      ?.clientLocationType && (
                                                      <MediumTypography
                                                        label="Client Location is Required"
                                                        sxProps={{
                                                          marginTop: '24px',
                                                          color:
                                                            'var(--thom-radical-red)',
                                                          position: 'absolute',
                                                        }}
                                                      />
                                                    )}
                                                </Box>
                                              </Box>

                                              {/* CoTx and Type */}
                                              <Box
                                                sx={{
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                }}
                                              >
                                                {/* CoTx */}
                                                <Box>
                                                  <MediumTypography
                                                    labelid="ProgressNote.Modifier"
                                                    defaultlabel="Modifier:"
                                                    sxProps={{
                                                      paddingRight: '8px',
                                                      fontSize: '16px',
                                                    }}
                                                    textColor="#97A6A5"
                                                  />
                                                </Box>
                                                <Box
                                                  sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    marginRight: '24px',
                                                  }}
                                                >
                                                  <CheckBoxComponent
                                                    ischecked={
                                                      values.clients[
                                                        openAccordianIndex
                                                      ].visits[index]?.coTx
                                                    }
                                                    CheckHandleChange={(
                                                      value,
                                                    ) => {
                                                      if (
                                                        value.target.checked
                                                      ) {
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.coTx`,
                                                          value.target.checked,
                                                        );
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.ifspMeeting`,
                                                          false,
                                                        );
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.asessmentHomeVisit`,
                                                          false,
                                                        );
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.supervisionCoTxHV`,
                                                          false,
                                                        );
                                                        setTimeout(() => {
                                                          handelCoTreatmentDuration(
                                                            index,
                                                            value.target
                                                              .checked,
                                                          );
                                                        }, 100);
                                                      } else {
                                                        setTimeout(() => {
                                                          handelCoTreatmentDuration(
                                                            index,
                                                            value.target
                                                              .checked,
                                                          );
                                                        }, 100);
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.coTx`,
                                                          value.target.checked,
                                                        );
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.coTreatPartnerName`,
                                                          [],
                                                        );
                                                      }
                                                    }}
                                                    disabled={
                                                      item.status ===
                                                        'Completed' ||
                                                      item.status ===
                                                        'Canceled' ||
                                                      !validUser ||
                                                      (values.clients[
                                                        openAccordianIndex
                                                      ].visits[index]
                                                        .serviceCode.id !==
                                                        'TA' &&
                                                        values.clients[
                                                          openAccordianIndex
                                                        ].visits[index]
                                                          .serviceCode.id !==
                                                          'TB') ||
                                                      visit.activitySheetStatus ===
                                                        'Approved' ||
                                                      (isScreenLocked &&
                                                        !!formikRef.current
                                                          ?.values.clients[
                                                          openAccordianIndex
                                                        ].canceledReason
                                                          ?.cancelReason)
                                                    }
                                                    labelid="ProgressNote.CoTreatment"
                                                    defaultlabelid="Co-Treatment"
                                                  />
                                                </Box>
                                                <Box
                                                  sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    marginRight: '24px',
                                                  }}
                                                >
                                                  <CheckBoxComponent
                                                    ischecked={
                                                      values.clients[
                                                        openAccordianIndex
                                                      ].visits[index]
                                                        ?.ifspMeeting
                                                    }
                                                    CheckHandleChange={(
                                                      value,
                                                    ) => {
                                                      setFieldValue(
                                                        `clients.${openAccordianIndex}.visits.${index}.coTreatPartnerName`,
                                                        [],
                                                      );
                                                      setFieldValue(
                                                        `clients.${openAccordianIndex}.visits.${index}.ifspMeeting`,
                                                        value.target.checked,
                                                      );
                                                      setFieldValue(
                                                        `clients.${openAccordianIndex}.visits.${index}.asessmentHomeVisit`,
                                                        false,
                                                      );
                                                      setFieldValue(
                                                        `clients.${openAccordianIndex}.visits.${index}.coTx`,
                                                        false,
                                                      );
                                                      setFieldValue(
                                                        `clients.${openAccordianIndex}.visits.${index}.supervisionCoTxHV`,
                                                        false,
                                                      );
                                                      setTimeout(() => {
                                                        handelCoTreatmentDuration(
                                                          index,
                                                          false,
                                                        );
                                                      }, 100);
                                                    }}
                                                    disabled={
                                                      item.status ===
                                                        'Completed' ||
                                                      item.status ===
                                                        'Canceled' ||
                                                      !validUser ||
                                                      (values.clients[
                                                        openAccordianIndex
                                                      ].visits[index]
                                                        .serviceCode.id !==
                                                        'TA' &&
                                                        values.clients[
                                                          openAccordianIndex
                                                        ].visits[index]
                                                          .serviceCode.id !==
                                                          'TB') ||
                                                      visit.activitySheetStatus ===
                                                        'Approved' ||
                                                      (isScreenLocked &&
                                                        !!formikRef.current
                                                          ?.values.clients[
                                                          openAccordianIndex
                                                        ].canceledReason
                                                          ?.cancelReason)
                                                    }
                                                    labelid="ProgressNote.IFSPMeeting"
                                                    defaultlabelid="IFSP Meeting"
                                                  />
                                                </Box>
                                                <Box
                                                  sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    marginRight: '24px',
                                                  }}
                                                >
                                                  <CheckBoxComponent
                                                    ischecked={
                                                      values.clients[
                                                        openAccordianIndex
                                                      ].visits[index]
                                                        ?.asessmentHomeVisit
                                                    }
                                                    CheckHandleChange={(
                                                      value,
                                                    ) => {
                                                      setFieldValue(
                                                        `clients.${openAccordianIndex}.visits.${index}.coTreatPartnerName`,
                                                        [],
                                                      );
                                                      setFieldValue(
                                                        `clients.${openAccordianIndex}.visits.${index}.asessmentHomeVisit`,
                                                        value.target.checked,
                                                      );
                                                      setFieldValue(
                                                        `clients.${openAccordianIndex}.visits.${index}.coTx`,
                                                        false,
                                                      );
                                                      setFieldValue(
                                                        `clients.${openAccordianIndex}.visits.${index}.ifspMeeting`,
                                                        false,
                                                      );
                                                      setFieldValue(
                                                        `clients.${openAccordianIndex}.visits.${index}.supervisionCoTxHV`,
                                                        false,
                                                      );
                                                      setTimeout(() => {
                                                        handelCoTreatmentDuration(
                                                          index,
                                                          false,
                                                        );
                                                      }, 100);
                                                    }}
                                                    disabled={
                                                      item.status ===
                                                        'Completed' ||
                                                      item.status ===
                                                        'Canceled' ||
                                                      !validUser ||
                                                      values.clients[
                                                        openAccordianIndex
                                                      ].visits[index]
                                                        .serviceCode.id !==
                                                        'TA' ||
                                                      visit.activitySheetStatus ===
                                                        'Approved' ||
                                                      (isScreenLocked &&
                                                        !!formikRef.current
                                                          ?.values.clients[
                                                          openAccordianIndex
                                                        ].canceledReason
                                                          ?.cancelReason)
                                                    }
                                                    labelid="ProgressNote.AssessmentHomeVisit"
                                                    defaultlabelid="Assessment Home Visit"
                                                  />
                                                </Box>
                                                <Box
                                                  sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    marginRight: '24px',
                                                  }}
                                                >
                                                  <CheckBoxComponent
                                                    ischecked={
                                                      values.clients[
                                                        openAccordianIndex
                                                      ].visits[index]
                                                        ?.supervisionCoTxHV
                                                    }
                                                    CheckHandleChange={(
                                                      value,
                                                    ) => {
                                                      setFieldValue(
                                                        `clients.${openAccordianIndex}.visits.${index}.coTreatPartnerName`,
                                                        [],
                                                      );
                                                      setFieldValue(
                                                        `clients.${openAccordianIndex}.visits.${index}.supervisionCoTxHV`,
                                                        value.target.checked,
                                                      );
                                                      setFieldValue(
                                                        `clients.${openAccordianIndex}.visits.${index}.coTx`,
                                                        false,
                                                      );
                                                      setFieldValue(
                                                        `clients.${openAccordianIndex}.visits.${index}.ifspMeeting`,
                                                        false,
                                                      );
                                                      setFieldValue(
                                                        `clients.${openAccordianIndex}.visits.${index}.asessmentHomeVisit`,
                                                        false,
                                                      );
                                                      setTimeout(() => {
                                                        handelCoTreatmentDuration(
                                                          index,
                                                          false,
                                                        );
                                                      }, 100);
                                                    }}
                                                    disabled={true}
                                                    labelid="ProgressNote.SupervisionCoTxHV"
                                                    defaultlabelid="Supervision Co-Tx HV"
                                                  />
                                                </Box>

                                                {/* Type */}
                                                <Box
                                                  sx={{
                                                    display: 'none',
                                                    alignItems: 'center',
                                                  }}
                                                >
                                                  <MediumTypography
                                                    labelid="ProgressNote.Type"
                                                    defaultlabel="Type:"
                                                    sxProps={{
                                                      paddingRight: '8px',
                                                      fontSize: '16px',
                                                    }}
                                                    textColor="#97A6A5"
                                                  />
                                                  <Box sx={{ display: 'flex' }}>
                                                    <CustomRadioButton
                                                      needUnSelect={false}
                                                      data={
                                                        appointmentStageRadioData
                                                      }
                                                      onSelectItem={(value) => {
                                                        setFieldValue(
                                                          `clients.${openAccordianIndex}.visits.${index}.appointmentStage`,
                                                          value,
                                                        );
                                                      }}
                                                      value={
                                                        values.clients[
                                                          sectionIndex
                                                        ].visits[index]
                                                          ?.appointmentStage
                                                      }
                                                      disable={
                                                        item.status ===
                                                          'Completed' ||
                                                        item.status ===
                                                          'Canceled' ||
                                                        !validUser ||
                                                        visit.activitySheetStatus ===
                                                          'Approved' ||
                                                        (isScreenLocked &&
                                                          !!formikRef.current
                                                            ?.values.clients[
                                                            openAccordianIndex
                                                          ].canceledReason
                                                            ?.cancelReason)
                                                      }
                                                    />
                                                    {errors.clients?.[
                                                      openAccordianIndex
                                                    ] &&
                                                      (
                                                        errors.clients[
                                                          openAccordianIndex
                                                        ] as FormikErrors<ProgressNoteClient>
                                                      ).visits &&
                                                      (
                                                        (
                                                          errors.clients[
                                                            openAccordianIndex
                                                          ] as FormikErrors<ProgressNoteClient>
                                                        )
                                                          .visits as FormikErrors<
                                                          ProgressNoteVisit[]
                                                        >
                                                      )[index]
                                                        ?.appointmentStage &&
                                                      touched.clients?.[
                                                        openAccordianIndex
                                                      ]?.visits?.[index] &&
                                                      touched.clients?.[
                                                        openAccordianIndex
                                                      ]?.visits?.[index]
                                                        ?.appointmentStage && (
                                                        <MediumTypography
                                                          labelid={
                                                            (
                                                              errors.clients[
                                                                openAccordianIndex
                                                              ] as FormikErrors<ProgressNoteClient>
                                                            ).visits &&
                                                            (
                                                              (
                                                                errors.clients[
                                                                  openAccordianIndex
                                                                ] as FormikErrors<ProgressNoteClient>
                                                              )
                                                                .visits as FormikErrors<
                                                                ProgressNoteVisit[]
                                                              >
                                                            )[index]
                                                              ?.appointmentStage
                                                          }
                                                          defaultlabel="Type is Required"
                                                          sxProps={{
                                                            color:
                                                              'var( --thom-radical-red)',
                                                            position:
                                                              'absolute',
                                                            paddingTop: '18px',
                                                          }}
                                                        />
                                                      )}
                                                  </Box>
                                                </Box>
                                              </Box>

                                              {values.clients[
                                                openAccordianIndex
                                              ].visits[index].coTx && (
                                                <>
                                                  <Grid
                                                    xs={12}
                                                    container
                                                    sx={{ marginTop: '16px' }}
                                                  >
                                                    <Grid
                                                      item
                                                      xs={6}
                                                      sx={{
                                                        paddingRight: '20px',
                                                      }}
                                                    >
                                                      <MultipleAutocompleteSearch
                                                        data={[
                                                          ...(props.progressNoteData.clients[
                                                            openAccordianIndex
                                                          ].attendeeList
                                                            ?.filter(
                                                              (clickedId) =>
                                                                clickedId.attendeeId !==
                                                                props.clickedAttendeeId,
                                                            )
                                                            .map(
                                                              (
                                                                filteredValue,
                                                              ) => ({
                                                                id: filteredValue.attendeeId,
                                                                label: `${filteredValue.lastName}, ${filteredValue.firstName}`,
                                                              }),
                                                            ) || []),
                                                          {
                                                            id: 'VISION_PROVIDER',
                                                            label:
                                                              'Vision Provider',
                                                          },
                                                          {
                                                            id: 'DHOH_PROVIDER',
                                                            label:
                                                              'DHOH Provider',
                                                          },
                                                        ]}
                                                        labelId="ProgressNote.Clinician"
                                                        defaultId="Clinician"
                                                        onSelectItem={(
                                                          value,
                                                        ) => {
                                                          if (value) {
                                                            const coTreatPartnerNameIds =
                                                              value.map(
                                                                (coValue) =>
                                                                  coValue.id,
                                                              );
                                                            setFieldValue(
                                                              `clients.${openAccordianIndex}.visits.${index}.coTreatPartnerName`,
                                                              coTreatPartnerNameIds,
                                                            );
                                                          } else {
                                                            setFieldValue(
                                                              `clients.${openAccordianIndex}.visits.${index}.coTreatPartnerName`,
                                                              null,
                                                            );
                                                          }
                                                        }}
                                                        value={values.clients[
                                                          openAccordianIndex
                                                        ].visits[
                                                          index
                                                        ].coTreatPartnerName.map(
                                                          (coValue) => {
                                                            if (
                                                              coValue ===
                                                                'VISION_PROVIDER' ||
                                                              coValue ===
                                                                'DHOH_PROVIDER'
                                                            ) {
                                                              return {
                                                                id: coValue,
                                                                label:
                                                                  coValue ===
                                                                  'VISION_PROVIDER'
                                                                    ? 'Vision Provider'
                                                                    : 'DHOH Provider',
                                                              };
                                                            }
                                                            return {
                                                              id: coValue,
                                                              label: formatName(
                                                                values.clients[
                                                                  openAccordianIndex
                                                                ].attendeeList?.find(
                                                                  (attendee) =>
                                                                    attendee.attendeeId ===
                                                                    coValue,
                                                                )?.firstName ??
                                                                  '',
                                                                null,
                                                                values.clients[
                                                                  openAccordianIndex
                                                                ].attendeeList?.find(
                                                                  (attendee) =>
                                                                    attendee.attendeeId ===
                                                                    coValue,
                                                                )?.lastName ??
                                                                  '',
                                                                null,
                                                              ),
                                                            };
                                                          },
                                                        )}
                                                        disableLabel={false}
                                                        disabled={
                                                          item.status ===
                                                            'Completed' ||
                                                          item.status ===
                                                            'Canceled' ||
                                                          !validUser ||
                                                          visit.activitySheetStatus ===
                                                            'Approved' ||
                                                          (isScreenLocked &&
                                                            !!formikRef.current
                                                              ?.values.clients[
                                                              openAccordianIndex
                                                            ].canceledReason
                                                              ?.cancelReason)
                                                        }
                                                      />
                                                    </Grid>
                                                  </Grid>
                                                  <Box>
                                                    {errors.clients?.[
                                                      openAccordianIndex
                                                    ] &&
                                                      (
                                                        errors.clients[
                                                          openAccordianIndex
                                                        ] as FormikErrors<ProgressNoteClient>
                                                      ).visits &&
                                                      (
                                                        (
                                                          errors.clients[
                                                            openAccordianIndex
                                                          ] as FormikErrors<ProgressNoteClient>
                                                        )
                                                          .visits as FormikErrors<
                                                          ProgressNoteVisit[]
                                                        >
                                                      )[index]
                                                        ?.coTreatPartnerName &&
                                                      touched.clients?.[
                                                        openAccordianIndex
                                                      ]?.visits?.[index] &&
                                                      touched.clients?.[
                                                        openAccordianIndex
                                                      ]?.visits?.[index]
                                                        ?.coTreatPartnerName && (
                                                        <MediumTypography
                                                          labelid={
                                                            (
                                                              errors.clients[
                                                                openAccordianIndex
                                                              ] as FormikErrors<ProgressNoteClient>
                                                            ).visits &&
                                                            ((
                                                              (
                                                                errors.clients[
                                                                  openAccordianIndex
                                                                ] as FormikErrors<ProgressNoteClient>
                                                              )
                                                                .visits as FormikErrors<
                                                                ProgressNoteVisit[]
                                                              >
                                                            )[index]
                                                              ?.coTreatPartnerName as string)
                                                          }
                                                          defaultlabel="Clinician is Required"
                                                          sxProps={{
                                                            color:
                                                              'var( --thom-radical-red)',
                                                            // position: 'absolute',
                                                            marginTop: '8px',
                                                          }}
                                                        />
                                                      )}
                                                  </Box>
                                                </>
                                              )}
                                            </Box>
                                            <Box
                                              sx={{
                                                display: 'flex',
                                                cursor: 'pointer',
                                                justifyContent: 'flex-end',
                                                alignItems: 'flex-end',
                                                marginBottom:
                                                  index !==
                                                  initialData.clients[
                                                    openAccordianIndex
                                                  ].visits.length -
                                                    1
                                                    ? '24px'
                                                    : '16px',
                                                marginLeft: '8px',
                                              }}
                                            >
                                              {values.clients[
                                                openAccordianIndex
                                              ].visits.length > 1 &&
                                                validUser &&
                                                item.status !== 'Completed' &&
                                                item.status !== 'Canceled' &&
                                                visit.activitySheetStatus !==
                                                  'Approved' &&
                                                !isScreenLocked &&
                                                !formikRef.current?.values
                                                  .clients[openAccordianIndex]
                                                  .canceledReason
                                                  ?.cancelReason && (
                                                  <Delete
                                                    onClick={() => {
                                                      if (formikRef.current) {
                                                        const clientsTouched =
                                                          touched.clients ?? [];
                                                        const { clients } =
                                                          formikRef.current
                                                            .values;

                                                        if (
                                                          clients?.[
                                                            openAccordianIndex
                                                          ]
                                                        ) {
                                                          const currentClient =
                                                            clients[
                                                              openAccordianIndex
                                                            ];
                                                          const clientTouched =
                                                            clientsTouched[
                                                              openAccordianIndex
                                                            ] || {};
                                                          const clientVisits =
                                                            clientTouched.visits ||
                                                            [];

                                                          // Create touchedVisit object with all fields marked as false
                                                          const touchedVisit: {
                                                            [
                                                              key: string
                                                            ]: boolean;
                                                          } = {};
                                                          Object.keys(
                                                            currentClient
                                                              .visits[index] ||
                                                              {},
                                                          ).forEach((key) => {
                                                            touchedVisit[key] =
                                                              false;
                                                          });

                                                          // Ensure that the visits array is not empty before accessing its length
                                                          if (
                                                            currentClient.visits
                                                              .length > 0
                                                          ) {
                                                            // Assign touchedVisit to the last visit of the current client
                                                            clientVisits[
                                                              currentClient
                                                                .visits.length -
                                                                1
                                                            ] = touchedVisit;
                                                          }

                                                          // Update clientTouched object
                                                          clientTouched.visits =
                                                            clientVisits;
                                                          clientsTouched[
                                                            openAccordianIndex
                                                          ] = clientTouched;

                                                          // Update Formik's touched state
                                                          formikRef.current.setTouched(
                                                            {
                                                              ...touched,
                                                              clients:
                                                                clientsTouched,
                                                            },
                                                          );
                                                        }
                                                      }
                                                      deleteVisit(
                                                        index,
                                                        values.clients[
                                                          sectionIndex
                                                        ].visits[index].id,
                                                      );
                                                    }}
                                                  />
                                                )}
                                            </Box>
                                          </Box>
                                        ))}

                                        {validUser &&
                                          item.status !== 'Completed' &&
                                          item.activitySheetStatus !==
                                            'Submitted' &&
                                          item.activitySheetStatus !==
                                            'Approved' &&
                                          editClientIndex === null && (
                                            <Box
                                              sx={{
                                                marginTop: '16px',
                                                cursor: 'pointer',
                                                display: 'inline-flex',
                                              }}
                                              onClick={addVisit}
                                            >
                                              <MediumTypography
                                                labelid="ProgressNote.AddVisit"
                                                defaultlabel="+ Add More"
                                                textColor="#00C6B8"
                                                fontSize="16px"
                                                fontweight={700}
                                                sxProps={{
                                                  textDecorationLine:
                                                    'underline',
                                                  textUnderlineOffset: '3px',
                                                }}
                                              />
                                            </Box>
                                          )}
                                      </Box>
                                      {/* Visiter */}
                                      <Box
                                        sx={{
                                          paddingY: '24px',
                                          marginX: '24px',
                                          borderBottom: '1px solid #00C6B8',
                                        }}
                                      >
                                        <MediumTypography
                                          labelid="ProgressNote.PresentForVisit"
                                          defaultlabel="Present for Visit"
                                          textColor="#213262"
                                          sxProps={{
                                            fontSize: '18px',
                                            fontWeight: 600,
                                            paddingBottom: '16px',
                                          }}
                                        />
                                        <Box
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              width: '400px',
                                              paddingRight: '16px',
                                            }}
                                          >
                                            <MultipleAutocompleteSearch
                                              data={item?.contact
                                                ?.filter(
                                                  (contact) =>
                                                    contact.name &&
                                                    contact.type !== 'Family',
                                                )
                                                .map((contact) => {
                                                  const prefixes = [
                                                    contact.isPrimary &&
                                                      'Primary',
                                                    contact.isLegal && 'Legal',
                                                  ].filter(Boolean);
                                                  return {
                                                    id: contact.contactId,
                                                    label:
                                                      contact.isGuardian &&
                                                      prefixes.length > 0
                                                        ? `${
                                                            contact.name ??
                                                            'Referral Contact'
                                                          } - (${prefixes.join(
                                                            ', ',
                                                          )})`
                                                        : contact.name ??
                                                          'Referral Contact',
                                                  };
                                                })}
                                              sxProps={{
                                                backgroundColor:
                                                  item.status === 'Completed' ||
                                                  !validUser
                                                    ? '#CFDEDE'
                                                    : '#ffffff',
                                              }}
                                              labelId="ProgressNote.SelectConatct"
                                              defaultId="Select name"
                                              onSelectItem={(value) => {
                                                const selectedContactIds =
                                                  value.map(
                                                    (contact) => contact.id,
                                                  );
                                                setFieldValue(
                                                  `clients.${openAccordianIndex}.selectedContacts`,
                                                  selectedContactIds,
                                                );
                                                const filteredContacts =
                                                  item.contact.filter(
                                                    (contact) =>
                                                      selectedContactIds.includes(
                                                        contact.contactId,
                                                      ),
                                                  );
                                                setMultiSelectContact(
                                                  filteredContacts,
                                                );
                                              }}
                                              value={values.clients[
                                                openAccordianIndex
                                              ].selectedContacts.map(
                                                (contactId) => {
                                                  const contact =
                                                    values.clients[
                                                      sectionIndex
                                                    ].contact.find(
                                                      (c) =>
                                                        c.contactId ===
                                                        contactId,
                                                    );
                                                  const prefixes = [
                                                    contact?.isPrimary &&
                                                      'Primary',
                                                    contact?.isLegal && 'Legal',
                                                  ].filter(Boolean);
                                                  const label =
                                                    contact?.isGuardian &&
                                                    prefixes.length > 0
                                                      ? `${
                                                          contact?.name || ''
                                                        } - (${prefixes.join(
                                                          ', ',
                                                        )})`
                                                      : contact?.name || '';
                                                  return {
                                                    id: contactId,
                                                    label,
                                                  };
                                                },
                                              )}
                                              optionHintId={'No contacts found'}
                                              disabled={
                                                (item.status === 'Completed' ||
                                                  item.status === 'Canceled' ||
                                                  item.activitySheetStatus ===
                                                    'Submitted' ||
                                                  item.activitySheetStatus ===
                                                    'Approved' ||
                                                  !validUser ||
                                                  (isScreenLocked &&
                                                    !!formikRef.current?.values
                                                      .clients[
                                                      openAccordianIndex
                                                    ].canceledReason
                                                      ?.cancelReason)) &&
                                                editClientIndex === null
                                              }
                                            />
                                          </Box>
                                        </Box>
                                        {multiSelectContact &&
                                        multiSelectContact.length > 0 ? (
                                          <SelectedContacts
                                            multiSelectContact={
                                              multiSelectContact
                                            }
                                          />
                                        ) : null}
                                      </Box>
                                      <Box
                                        sx={{
                                          paddingY: '24px',
                                          marginX: '24px',
                                          borderBottom: '1px solid #00C6B8',
                                        }}
                                      >
                                        <MediumTypography
                                          labelid="ProgressNote.OtherPresentForVisit"
                                          defaultlabel="Others present for the visit"
                                          textColor="#213262"
                                          sxProps={{
                                            fontSize: '18px',
                                            fontWeight: 600,
                                            paddingBottom: '16px',
                                          }}
                                        />
                                        <Textinput
                                          className="bg__white"
                                          autoComplete="off"
                                          sxProps={{ width: '385px' }}
                                          inputProps={{ maxLength: 200 }}
                                          defaultlabelid="Others present for the visit"
                                          labelid="ProgressNote.OtherPresentForVisit"
                                          Value={
                                            values.clients[openAccordianIndex]
                                              .othersPresentInVisit ?? ''
                                          }
                                          handlechange={(value: string) => {
                                            setFieldValue(
                                              `clients[${openAccordianIndex}].othersPresentInVisit`,
                                              value,
                                            );
                                          }}
                                          disabled={
                                            (item.status === 'Completed' ||
                                              item.status === 'Canceled' ||
                                              item.activitySheetStatus ===
                                                'Submitted' ||
                                              item.activitySheetStatus ===
                                                'Approved' ||
                                              !validUser ||
                                              (isScreenLocked &&
                                                !!formikRef.current?.values
                                                  .clients[openAccordianIndex]
                                                  .canceledReason
                                                  ?.cancelReason)) &&
                                            editClientIndex === null
                                          }
                                        />

                                        {/* {props.interpreter && (
                                          <Box className="text-align-end">
                                            <MediumTypography
                                              className="mainText-md mt-md"
                                              label={`* ${
                                                props.interpreter.firstName ??
                                                ''
                                              } ${
                                                props.interpreter.lastName ?? ''
                                              } ${rctl.formatMessage({
                                                id: 'interpreterExistText',
                                                defaultMessage:
                                                  'is present for the visit as interpreter',
                                              })}`}
                                            />
                                          </Box>
                                        )} */}
                                        {props.interpreter &&
                                          props.interpreter.length > 0 && (
                                            <Box
                                              className="text-align-end"
                                              sx={{ marginTop: '8px' }}
                                            >
                                              {props.interpreter.map(
                                                (attendee, attendeeIndex) => (
                                                  <MediumTypography
                                                    key={
                                                      attendee.attendeeId ??
                                                      attendeeIndex
                                                    }
                                                    className="mainText-md mt-md"
                                                    label={`${
                                                      attendee.firstName ?? ''
                                                    } ${
                                                      attendee.lastName ?? ''
                                                    }  ${rctl.formatMessage(
                                                      {
                                                        id: 'interpreterExistText',
                                                        defaultMessage:
                                                          'is present for the visit as {role}',
                                                      },
                                                      {
                                                        role:
                                                          attendee.attendeeRole ===
                                                          AttendeeRole.GROUP_ASSISTANT
                                                            ? 'Group Assistant'
                                                            : attendee.attendeeRole ===
                                                              AttendeeRole.INTERPRETER
                                                            ? 'Interpreter'
                                                            : attendee.attendeeRole,
                                                      },
                                                    )}`}
                                                  />
                                                ),
                                              )}
                                            </Box>
                                          )}
                                      </Box>
                                    </Box>
                                  </Box>
                                  {/* Comment */}
                                  {item.client.clientId ===
                                  values.clients[openAccordianIndex].client
                                    .clientId ? (
                                    <Box
                                      sx={{
                                        paddingY: '24px',
                                        marginX: '24px',
                                        borderBottom: '1px solid #00C6B8',
                                      }}
                                    >
                                      <MediumTypography
                                        labelid="ProgressNote.Notes"
                                        defaultlabel="Notes"
                                        textColor="#213262"
                                        sxProps={{
                                          fontSize: '18px',
                                          fontWeight: 600,
                                          paddingBottom: '16px',
                                        }}
                                      />
                                      <VoiceRecognition
                                        initialNote={
                                          item.client.clientId ===
                                          values.clients[openAccordianIndex]
                                            .client.clientId
                                            ? values.clients[openAccordianIndex]
                                                .notes
                                            : 'kuh'
                                        }
                                        onNoteChange={(value: string) => {
                                          setFieldValue(
                                            `clients[${openAccordianIndex}].notes`,
                                            value,
                                          );
                                        }}
                                        disabled={
                                          item.status === 'Completed' ||
                                          item.status === 'Canceled' ||
                                          !validUser ||
                                          item.activitySheetStatus ===
                                            'Submitted' ||
                                          item.activitySheetStatus ===
                                            'Approved' ||
                                          editClientIndex !== null
                                        }
                                        required={editClientIndex === null}
                                      />
                                      {errors.clients?.[openAccordianIndex] &&
                                        (
                                          errors.clients[
                                            openAccordianIndex
                                          ] as FormikErrors<ProgressNoteClient>
                                        ).notes &&
                                        touched?.clients?.[openAccordianIndex]
                                          .notes && (
                                          <MediumTypography
                                            labelid={
                                              (
                                                errors.clients[
                                                  openAccordianIndex
                                                ] as FormikErrors<ProgressNoteClient>
                                              ).notes
                                            }
                                            defaultlabel="Note is Required"
                                            sxProps={{
                                              paddingTop: '8px',
                                              color: 'var( --thom-radical-red)',
                                            }}
                                          />
                                        )}
                                    </Box>
                                  ) : null}
                                  {/* Signature */}
                                  <Box
                                    sx={{ marginTop: '24px', marginX: '24px' }}
                                  >
                                    <MediumTypography
                                      labelid="ProgressNote.Signature"
                                      defaultlabel="Signature"
                                      textColor="#213262"
                                      sxProps={{
                                        fontSize: '18px',
                                        fontWeight: 600,
                                        paddingBottom: '8px',
                                      }}
                                    />
                                    <Box sx={{ paddingBottom: '24px' }}>
                                      {values.clients[openAccordianIndex]
                                        .signature.signatureValue === '' && (
                                        <ButtonComponent
                                          className="btn-primary btn-cancel signature_add_Box"
                                          labelId="Insurance.Addsignature"
                                          defaultLabelId="Add Signature"
                                          variantType="outlined"
                                          onClick={() => setSignClicked(true)}
                                          disabled={
                                            !validUser ||
                                            offline ||
                                            item.activitySheetStatus ===
                                              'Submitted' ||
                                            item.activitySheetStatus ===
                                              'Approved'
                                          }
                                        />
                                      )}
                                      {values.clients[openAccordianIndex]
                                        .signature.signatureValue !== '' && (
                                        <ButtonComponent
                                          className="btn-primary btn-cancel signature_view_Box"
                                          labelId={
                                            item.status === 'Completed'
                                              ? 'ProgressNoteViewSignature'
                                              : 'ProgressNote.ViewUpdateSignature'
                                          }
                                          defaultLabelId={
                                            item.status === 'Completed'
                                              ? 'View signature'
                                              : 'View/update signature'
                                          }
                                          variantType="outlined"
                                          LeftIcon={<Editsignature />}
                                          onClick={() => setSignClicked(true)}
                                          disabled={offline}
                                        />
                                      )}
                                    </Box>
                                    <Box sx={{ display: '' }}>
                                      <Box sx={{ display: 'flex' }}>
                                        <MediumTypography
                                          labelid="name"
                                          defaultlabel="Name:"
                                          textColor="#97A6A5"
                                          sxProps={{ fontSize: '16px' }}
                                        />
                                        <MediumTypography
                                          sxProps={{
                                            fontSize: '16px',
                                            fontWeight: 500,
                                            paddingLeft: '6px',
                                            color: '#2A4241',
                                          }}
                                          label={
                                            attendeeName === ''
                                              ? '-'
                                              : attendeeName
                                          }
                                        />
                                      </Box>
                                      <Box
                                        sx={{
                                          display: 'flex',
                                          paddingTop: '16px',
                                        }}
                                      >
                                        {(attendeeDiscipline !== '' ||
                                          attendeeDiscipline !== null) && (
                                          <Box sx={{ display: 'flex' }}>
                                            <MediumTypography
                                              labelid="ProgressNOte.Discipline"
                                              defaultlabel="Discipline:"
                                              textColor="#97A6A5"
                                              sxProps={{
                                                fontSize: '16px',
                                              }}
                                            />
                                            <MediumTypography
                                              sxProps={{
                                                fontSize: '16px',
                                                fontWeight: 500,
                                                paddingLeft: '6px',
                                                color: '#2A4241',
                                                fontFamily: 'Lato-Regular',
                                              }}
                                              label={attendeeDiscipline || '-'}
                                            />
                                          </Box>
                                        )}
                                        {(attendeeLicenseNo !== '' ||
                                          attendeeLicenseNo !== null) && (
                                          <Box sx={{ display: 'flex' }}>
                                            <MediumTypography
                                              labelid="ProgressNote.LicenseNo"
                                              defaultlabel="License No:"
                                              textColor="#97A6A5"
                                              sxProps={{
                                                fontSize: '16px',
                                                paddingLeft: '32px',
                                              }}
                                            />
                                            <MediumTypography
                                              sxProps={{
                                                fontSize: '16px',
                                                fontWeight: 500,
                                                paddingLeft: '6px',
                                                color: '#2A4241',
                                                fontFamily: 'Lato-Regular',
                                              }}
                                              label={attendeeLicenseNo || '-'}
                                            />
                                          </Box>
                                        )}
                                      </Box>
                                    </Box>

                                    {/* Edit Logs */}
                                    {values.clients[openAccordianIndex]
                                      .editorSignatures &&
                                      values.clients[openAccordianIndex]
                                        .editorSignatures.length > 0 && (
                                        <Box
                                          sx={{
                                            marginTop: '24px',
                                            padding: '16px',
                                            backgroundColor: 'var(--white)',
                                            borderRadius: '4px',
                                          }}
                                        >
                                          <MediumTypography
                                            labelid="insurance.lastUpdated"
                                            defaultlabel="Last Updated By :"
                                            textColor="#213262"
                                            sxProps={{
                                              fontSize: '18px',
                                              fontWeight: 600,
                                              paddingBottom: '16px',
                                            }}
                                          />
                                          {values.clients[
                                            openAccordianIndex
                                          ].editorSignatures?.map(
                                            (log, logIdx) => (
                                              <Box
                                                key={log.id || logIdx}
                                                sx={{
                                                  marginBottom: '16px',
                                                  paddingBottom: '16px',
                                                  borderBottom:
                                                    logIdx <
                                                    (values.clients[
                                                      openAccordianIndex
                                                    ].editorSignatures
                                                      ?.length ?? 0) -
                                                      1
                                                      ? '1px solid #CFDEDE'
                                                      : 'none',
                                                  display: 'flex',
                                                  justifyContent:
                                                    'space-between',
                                                }}
                                              >
                                                <Box>
                                                  <Box className="flex__ mt-xs">
                                                    <MediumTypography label="By" />
                                                    <MediumTypography
                                                      className="ml-xs mainText-lg"
                                                      label={`${formatName(
                                                        log.firstName ?? '',
                                                        null,
                                                        log.lastName ?? '',
                                                        null,
                                                      )} `}
                                                      fontweight={500}
                                                      textColor="var(--thom-green-primary2)"
                                                    />
                                                    <MediumTypography
                                                      className="ml-xs mainText-md"
                                                      label={`on ${moment(
                                                        log.date,
                                                      )
                                                        .utc()
                                                        .local()
                                                        .format(
                                                          LOCAL_DATE_TIME_FORMAT,
                                                        )}`}
                                                    />
                                                  </Box>

                                                  {log.comment && (
                                                    <Box
                                                      sx={{
                                                        mt: 1,
                                                        maxWidth: '600px',
                                                        wordWrap: 'break-word',
                                                        overflowWrap:
                                                          'break-word',
                                                      }}
                                                    >
                                                      <MediumTypography
                                                        className="mt-xs"
                                                        label="Comments:"
                                                        textColor="#2A4241"
                                                        fontweight={600}
                                                      />
                                                      <MediumTypography
                                                        className="mt-xs"
                                                        label={log.comment}
                                                        textColor="#2A4241"
                                                        sxProps={{
                                                          wordWrap:
                                                            'break-word',
                                                          overflowWrap:
                                                            'break-word',
                                                          whiteSpace:
                                                            'pre-wrap',
                                                        }}
                                                      />
                                                    </Box>
                                                  )}
                                                </Box>
                                                <Box
                                                  sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                  }}
                                                >
                                                  {log.signature && (
                                                    <ButtonComponent
                                                      className="btn-primary btn-cancel signature_view_Box"
                                                      labelId="ProgressNoteViewSignature"
                                                      defaultLabelId="View signature"
                                                      variantType="outlined"
                                                      LeftIcon={
                                                        <Editsignature />
                                                      }
                                                      onClick={() =>
                                                        viewEditorSignature(log)
                                                      }
                                                    />
                                                  )}
                                                </Box>
                                              </Box>
                                            ),
                                          )}
                                        </Box>
                                      )}

                                    {/* Footer botton */}
                                    {validUser && (
                                      <Grid className="flex__ justifyContent-FlexEnd pt-lg ">
                                        <Grid item>
                                          <ButtonComponent
                                            className="btn-primary btn-cancel"
                                            labelId="ProgressNote.Cancel"
                                            defaultLabelId="Cancel"
                                            onClick={() => {
                                              for (const property of propertiesToCheck) {
                                                if (
                                                  !_.isEqual(
                                                    _.get(
                                                      origainalInitialData,
                                                      `clients[${openAccordianIndex}].${property}`,
                                                    ),
                                                    _.get(
                                                      values,
                                                      `clients[${openAccordianIndex}].${property}`,
                                                    ),
                                                  )
                                                ) {
                                                  hasChanged = true;
                                                  break;
                                                }
                                              }
                                              if (hasChanged) {
                                                setShowAlertDialog(true);
                                              } else if (
                                                !hasChanged &&
                                                clientCount === 1
                                              ) {
                                                navigateTo();
                                              } else if (
                                                !hasChanged &&
                                                clientCount > 1
                                              ) {
                                                setOpenAccordian(false);
                                              }
                                              turnOfMic();
                                              // }
                                            }}
                                          />
                                        </Grid>

                                        <Grid item>
                                          <ButtonComponent
                                            className="btn-primary btn-submit ml-md"
                                            labelId="ProgressNote.Save"
                                            defaultLabelId="Save"
                                            onClick={async () => {
                                              handleFormSubmission();
                                            }}
                                            disabled={
                                              item.status === 'Completed' ||
                                              item.status === 'Canceled' ||
                                              !validUser ||
                                              !enableSaveButton(item)
                                            }
                                          />
                                        </Grid>
                                      </Grid>
                                    )}
                                  </Box>
                                </Box>
                              )}
                          </Box>
                        );
                      })}
                  </Card>
                </Box>
              );
            }}
          </Formik>
        )}
      <ModalPopup
        open={isAnyDurationZero}
        onClose={() => setIsAnyDurationZero(false)}
        onOk={() => {
          setIsAnyDurationZero(false);
          turnOfMic();
          checkNoteEntered();
          handleOnSubmit(formikRef.current?.values as ProgressNoteType, false);
        }}
        onCancel={() => setIsAnyDurationZero(false)}
        description="ProgressNote.durationZeroError"
        labelId1="Clientpage.cancelbtn"
        negativeActionLabel="cancelText"
        labelId2="Clientpage.Okbtn"
        positiveActionLabel="Ok"
      />

      {historySignature && (
        <SignatureComponent
          signClicked={historySignature.open}
          labelId="signatureText"
          defaultLabelId="Signature"
          onCancelClick={() => setHistorySignature(null)}
          signature={historySignature.signature?.signature}
          signaturePartitionKey={historySignature.signature?.partitionKey ?? ''}
          signatureRowKey={historySignature.signature?.rowKey ?? ''}
          handleSuccess={() => {}}
          type="Employee"
          hideRemoveButton={true}
        />
      )}

      {/* Signature pad */}
      {signClicked && (
        <SignatureComponent
          signClicked={signClicked}
          labelId="signatureText"
          defaultLabelId="Signature"
          onCancelClick={onCancelClick}
          signature={
            formikRef.current?.values.clients[openAccordianIndex].signature
              .signatureValue
          }
          signaturePartitionKey={
            formikRef.current?.values.clients[openAccordianIndex].signature
              .partitionkey ?? ''
          }
          signatureRowKey={
            formikRef.current?.values.clients[openAccordianIndex].signature
              .rowkey ?? ''
          }
          signatureSaveOrUPdate={onSignatureSave}
          resetCallBackForTypeEmployee={clearSignature}
          signatureCallBack={signatureCallBack}
          handleSuccess={handleSuccess}
          type="Employee"
          hideRemoveButton={
            !validUser ||
            initialData?.clients[openAccordianIndex].activitySheetStatus ===
              'Submitted' ||
            initialData?.clients[openAccordianIndex].activitySheetStatus ===
              'Approved' ||
            editClientIndex !== null
          }
        />
      )}

      {/* Edit Signature pad */}
      {editSignClicked && (
        <SignatureComponent
          signClicked={editSignClicked}
          labelId="signatureText"
          defaultLabelId="Signature"
          onCancelClick={() => {
            setEditSignClicked(false);
          }}
          signature=""
          signaturePartitionKey=""
          signatureRowKey=""
          signatureSaveOrUPdate={() => {}}
          resetCallBackForTypeEmployee={() => {}}
          handleSuccess={handleSuccess}
          type="Employee"
          hideRemoveButton={true}
          showComments={true}
          onSaveWithComments={(signatureValue, comments) => {
            editPayloadRef.current = { comments, signatureValue };
            setEditSignClicked(false);
            turnOfMic();
            checkNoteEntered();

            // Check if this is a canceled+pending submission for PD
            if (
              formikRef?.current?.values.clients[openAccordianIndex]
                .canceledReason?.cancelReason &&
              formikRef.current.values.clients[openAccordianIndex].status ===
                'Pending'
            ) {
              handlePendingSubmit(formikRef.current.values);
            } else {
              formikRef.current?.submitForm();
            }
          }}
        />
      )}

      {showAlertDialog && (
        <ModalPopup
          open={showAlertDialog}
          onCancel={() => {
            setShowAlertDialog(false);
          }}
          description="formUnsavedChangesMessage"
          onOk={() => {
            navigateTo();
          }}
          labelId1="Clientpage.cancelbtn"
          negativeActionLabel="cancelText"
          labelId2="Clientpage.Okbtn"
          positiveActionLabel="Ok"
        />
      )}

      {/* Edit Confirmation Modal */}
      <ModalPopup
        open={editConfirmOpen}
        description="ProgressNote.EditConfirmation"
        defaultDescription="Do you want to update the Progress Notes?"
        labelId1="Clientpage.Nobtn"
        negativeActionLabel="No"
        labelId2="Clientpage.Yesbtn"
        positiveActionLabel="Yes"
        onCancel={() => {
          setEditConfirmOpen(false);
          setEditClientIndex(null);
        }}
        onOk={() => {
          setEditConfirmOpen(false);
          setOpenAccordianIndex(editClientIndex ?? 0);
          setOpenAccordian(true);
          const currentClient =
            formikRef.current?.values.clients[editClientIndex ?? 0];
          if (
            currentClient?.status === 'Canceled' ||
            currentClient?.status === 'Completed'
          ) {
            setValidUser(true);
            setIsScreenLocked(false);
            const newStatus =
              currentClient.visits.length > 0 &&
              currentClient.visits[0].serviceCode.label === ''
                ? 'Pending'
                : 'In Progress';
            const updatedClients =
              formikRef.current?.values.clients.map((client, idx) => {
                if (idx === editClientIndex) {
                  return {
                    ...client,
                    status: newStatus,
                    canceledReason: {
                      cancelReasonCode: '',
                      cancelReason: '',
                    },
                    cancelReason: '',
                  };
                }
                return client;
              }) ?? [];
            formikRef.current?.setFieldValue('clients', updatedClients);
            setInitialData((prev) => {
              if (!prev) return prev;
              return {
                ...prev,
                clients: prev.clients.map((client, idx) => {
                  if (idx === editClientIndex) {
                    return {
                      ...client,
                      status: newStatus,
                      canceledReason: {
                        cancelReasonCode: '',
                        cancelReason: '',
                      },
                      cancelReason: '',
                    };
                  }
                  return client;
                }),
              };
            });
          }
        }}
      />

      <ModalPopup
        open={groupBillingCancelModal}
        onCancel={() => {
          setGroupBillingCancelModal(false);
        }}
        description="formUnsavedChangesMessage"
        onOk={() => {
          setGroupBillingDuration(initialGroupBillingDuration);
          setGroupBillingStartTime(
            initialGroupBillingStartTime
              ? moment(
                  initialGroupBillingStartTime,
                  'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
                )
                  .utc(true)
                  .local()
                  .format('HH:mm')
              : '',
          );
          setGroupBillingCancelModal(false);
        }}
        labelId1="Clientpage.cancelbtn"
        negativeActionLabel="cancelText"
        labelId2="Clientpage.Okbtn"
        positiveActionLabel="Ok"
      />
      {/* Signature pad */}
      {signClicked && (
        <SignatureComponent
          signClicked={signClicked}
          labelId="signatureText"
          defaultLabelId="Signature"
          onCancelClick={onCancelClick}
          signature={
            formikRef.current?.values.clients[openAccordianIndex].signature
              .signatureValue
          }
          signaturePartitionKey={
            formikRef.current?.values.clients[openAccordianIndex].signature
              .partitionkey ?? ''
          }
          signatureRowKey={
            formikRef.current?.values.clients[openAccordianIndex].signature
              .rowkey ?? ''
          }
          signatureSaveOrUPdate={onSignatureSave}
          resetCallBackForTypeEmployee={clearSignature}
          signatureCallBack={signatureCallBack}
          handleSuccess={handleSuccess}
          type="Employee"
          hideRemoveButton={
            !validUser ||
            initialData?.clients[openAccordianIndex].activitySheetStatus ===
              'Submitted' ||
            initialData?.clients[openAccordianIndex].activitySheetStatus ===
              'Approved' ||
            editClientIndex !== null
          }
        />
      )}
      {/* Client selection checklist */}
      {firstEntry &&
      initialData?.clients.some((client) => client.isSelected) ? null : (
        <Dialog
          open={openClientModal && clientCount > 1 && validUser}
          fullWidth={false}
          maxWidth="xs"
          sx={{
            height: '70%',
            justifyContent: 'center',
            alignSelf: 'center',
            display: 'flex',
          }}
        >
          <DialogTitle sx={{ padding: '16px 16px 6px 16px' }}>
            <MediumTypography
              labelid="ProgressNote.CheckClient"
              defaultlabel="Choose Clients for Progress Note"
              fontSize="24px"
              fontweight={700}
              textColor="#2A4241"
            />
          </DialogTitle>
          <DialogContent sx={{ padding: '16px' }}>
            {clientCheckList.map((clientData) => (
              <Box
                key={clientData.clientId}
                className="flex__ alignItemFlexStart  pb-sm pt-sm"
                sx={{ borderBottom: '1px solid #CFDEDE' }}
              >
                <CheckBoxComponent
                  ischecked={clientData.isSelected}
                  CheckHandleChange={(e) => {
                    handleClientCheckBoxClick(
                      e.target.checked,
                      clientData.clientId,
                    );
                  }}
                  label={clientData.clientName}
                  disabled={
                    props.progressNoteData?.clients.some(
                      (client) =>
                        client.client.clientId === clientData.clientId &&
                        client.status === 'Canceled',
                    ) ||
                    props.progressNoteData?.clients.some(
                      (client) =>
                        client.client.clientId === clientData.clientId &&
                        client.status === 'Completed',
                    )
                  }
                />
              </Box>
            ))}
          </DialogContent>
          <DialogActions>
            <Box
              sx={{
                justifyContent: 'flex-end',
                display: 'flex',
                padding: '0px 16px 16px 0px',
              }}
            >
              <ButtonComponent
                variantType="contained"
                type="submit"
                className="btn-primary btn-submit alrt_Width_btn"
                labelId="ProgressNote.Add"
                defaultLabelId="Create"
                onClick={handleClientSaveCheckList}
                disabled={
                  clientCheckList.filter((item) => item.isSelected).length ===
                    0 ||
                  (!firstEntry &&
                    _.isEqual(clientCheckList, clientCheckListInitial))
                }
              />
              <ButtonComponent
                className="btn-primary btn-cancel alrt_Width_btn ml-md"
                variantType="contained"
                labelId="ProgressNote.Cancel"
                defaultLabelId="Cancel"
                onClick={handleClientCancelCheckList}
              />
            </Box>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default ProgressNote;
